const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDoing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-16--inject-92",
    cx: 250,
    cy: 316.14,
    rx: 234.39,
    ry: 150.34,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-16--inject-92",
    d: "M106.87,357.05l122.77,70.88a9.57,9.57,0,0,0,8.66,0L440.64,311.46c2.39-1.38,2.39-3.61,0-5L317.87,235.59a9.54,9.54,0,0,0-8.66,0L106.87,352.05C104.48,353.43,104.48,355.67,106.87,357.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-16--inject-92",
    cx: 392.82,
    cy: 244.53,
    rx: 36.88,
    ry: 21.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-16--inject-92",
    cx: 355.09,
    cy: 398.08,
    rx: 51.19,
    ry: 29.56,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.67,69.57c.32,1.05,5.31,4.88,5.53,6a1.32,1.32,0,0,0,1.67,1.08l4.88-1.33a1.21,1.21,0,0,1,.89.07h0c-.25-.13-10.41-6-10.74-6.21a1.16,1.16,0,0,0-.89-.08l-1.36.37h0Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.67,69.57c.32,1.05,5.31,4.88,5.53,6a1.32,1.32,0,0,0,1.67,1.08l4.88-1.33a1.21,1.21,0,0,1,.89.07h0c-.25-.13-10.41-6-10.74-6.21a1.16,1.16,0,0,0-.89-.08l-1.36.37h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09,57.08c.68.48,6.06,3.76,6.68,4.34a1.61,1.61,0,0,0,2.15,0l4.76-4.34a1.19,1.19,0,0,1,1.46-.16l0,0L227.34,50.7a1.18,1.18,0,0,0-1.4.2l-3.24,3-.35,1A2.06,2.06,0,0,0,223.09,57.08Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09,57.08c.68.48,6.06,3.76,6.68,4.34a1.61,1.61,0,0,0,2.15,0l4.76-4.34a1.19,1.19,0,0,1,1.46-.16l0,0L227.34,50.7a1.18,1.18,0,0,0-1.4.2l-3.24,3-.35,1A2.06,2.06,0,0,0,223.09,57.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.94,137.76l2.21-6.32a2,2,0,0,0-.74-2.21,18.52,18.52,0,0,1-2-1.59,1.62,1.62,0,0,0-2.16,0l-5.36-2.93-2.72,6.86a1.38,1.38,0,0,0,.62,1.68l10.74,6.22h0A1.39,1.39,0,0,1,183.94,137.76Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.94,137.76l2.21-6.32a2,2,0,0,0-.74-2.21,18.52,18.52,0,0,1-2-1.59,1.62,1.62,0,0,0-2.16,0l-5.36-2.93-2.72,6.86a1.38,1.38,0,0,0,.62,1.68l10.74,6.22h0A1.39,1.39,0,0,1,183.94,137.76Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,139.25l-.4-5A1.4,1.4,0,0,0,200,133a23.51,23.51,0,0,1-2.37.12c-.38,0-.76,0-1.13,0a1.65,1.65,0,0,0-1,.36,1.67,1.67,0,0,1,.28-.18l-4.53-.19a1.14,1.14,0,0,0,.49.89c.27.18,10.49,6.08,10.79,6.25l.1,0A1.08,1.08,0,0,1,202,139.25Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,139.25l-.4-5A1.4,1.4,0,0,0,200,133a23.51,23.51,0,0,1-2.37.12c-.38,0-.76,0-1.13,0a1.65,1.65,0,0,0-1,.36,1.67,1.67,0,0,1,.28-.18l-4.53-.19a1.14,1.14,0,0,0,.49.89c.27.18,10.49,6.08,10.79,6.25l.1,0A1.08,1.08,0,0,1,202,139.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,128.75l-2.31-2.94a1.45,1.45,0,0,0-2.06-.22l-.65.5.09-.07,5.33,3.08h0A1.28,1.28,0,0,1,221.1,128.75Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,128.75l-2.31-2.94a1.45,1.45,0,0,0-2.06-.22l-.65.5.09-.07,5.33,3.08h0A1.28,1.28,0,0,1,221.1,128.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9,98.39l-4.68-2.71a1.74,1.74,0,0,0,.94,1.08l3.74,1.63",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9,98.39l-4.68-2.71a1.74,1.74,0,0,0,.94,1.08l3.74,1.63",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.19,56c.74-.07,1.49-.11,2.23-.11.41,0,.82,0,1.22,0a2.18,2.18,0,0,0,1.87-1.23l2.85-5.75a1.82,1.82,0,0,1,2.08-.91l4.92,1.44a1.31,1.31,0,0,1,.47.24l-.12-.09-10.77-6.24a1.79,1.79,0,0,0-.32-.13l-4.93-1.44a1.81,1.81,0,0,0-2.07.91l-2.85,5.75a2.43,2.43,0,0,1-1.09,1.06l4.92,5.17A1.43,1.43,0,0,0,213.19,56Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.64,55.92a1.85,1.85,0,0,0,1.1-.36L207,49.34a3.37,3.37,0,0,1-.32.19l4.92,5.17a1.43,1.43,0,0,0,1.59,1.3c.74-.07,1.49-.11,2.23-.11C215.83,55.89,216.24,55.9,216.64,55.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.83,49.71l-.12-.09-10.77-6.24a1.79,1.79,0,0,0-.32-.13l-4.93-1.44a1.79,1.79,0,0,0-1.47.24L222,48.27a1.8,1.8,0,0,1,1.48-.24l4.92,1.44A1.31,1.31,0,0,1,228.83,49.71Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.22,42.05a1.68,1.68,0,0,0-.6.67l-2.85,5.75a2.39,2.39,0,0,1-.77.87l10.74,6.22a2.3,2.3,0,0,0,.77-.87l2.85-5.75a1.64,1.64,0,0,1,.59-.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.68,131.65l-2.93-4.77a2.17,2.17,0,0,1,.18-2.39l4.35-5.14a3,3,0,0,0,.48-2.53,29.31,29.31,0,0,1-.84-3.32,1.33,1.33,0,0,0-1.68-1.07l-8.22-1.8a2.93,2.93,0,0,1-.49,2.5l-4.34,5.14a2.17,2.17,0,0,0-.18,2.39l2.93,4.77a1.27,1.27,0,0,0,.48.47l10.73,6.21.14.07A1.29,1.29,0,0,1,174.68,131.65Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.76,116.82a29.31,29.31,0,0,1-.84-3.32,1.33,1.33,0,0,0-1.68-1.07l-8.22-1.8a3,3,0,0,1-.11,1.83l10.74,6.22A3,3,0,0,0,176.76,116.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.77,119.22l10.75,6.22a2,2,0,0,1,.41-1l4.35-5.14a2.18,2.18,0,0,0,.37-.67l-10.74-6.22a2.2,2.2,0,0,1-.38.67l-4.34,5.14A2,2,0,0,0,160.77,119.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15,132.11l.14.07a1.29,1.29,0,0,1-.61-.53l-2.93-4.77a2.08,2.08,0,0,1-.23-1.44l-10.75-6.22a2.08,2.08,0,0,0,.24,1.44l2.93,4.77a1.27,1.27,0,0,0,.48.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.05,112.63v-7.39a2.56,2.56,0,0,1,1.34-2.12l5-2.38a3.17,3.17,0,0,0,1.57-2.1c.24-1.46.56-2.93.94-4.4a1.77,1.77,0,0,0-1-2l-3.6-1.57a1.5,1.5,0,0,1-.78-2l3.33-7.91a2,2,0,0,1,2-1.13l4,.65a2.28,2.28,0,0,0,2.18-1c.84-1.47,1.73-2.9,2.67-4.27a2.84,2.84,0,0,0,.22-2.55l-1.85-3.89a2.31,2.31,0,0,1,.39-2.41l5.71-5.94a1.25,1.25,0,0,1,1.94.1l2.22,2.82a1.45,1.45,0,0,0,2.06.23c1.09-.86,2.2-1.66,3.32-2.38.3-.2.59-.38.89-.56a2.79,2.79,0,0,0,1-2l.39-5.25a2.52,2.52,0,0,1,1.5-2l6.19-2.31a1.13,1.13,0,0,1,1,.05h0c-.26-.15-10.45-6.06-10.75-6.22a1.13,1.13,0,0,0-1,0l-6.19,2.31a2.52,2.52,0,0,0-1.5,2l-.39,5.25a2.83,2.83,0,0,1-1,2c-.3.18-.6.36-.89.56-1,.61-1.89,1.27-2.81,2l-5.22-3a1.24,1.24,0,0,0-1.51.27l-5.72,5.94a2.33,2.33,0,0,0-.39,2.41l1.85,3.89a2.81,2.81,0,0,1-.22,2.55c-.93,1.37-1.83,2.8-2.67,4.27a2.26,2.26,0,0,1-2.18,1l-3.94-.65a2,2,0,0,0-2,1.13l-3.33,7.91a1.52,1.52,0,0,0,.6,1.87l4.71,2.72a1.74,1.74,0,0,1,0,1c-.38,1.47-.7,2.94-.95,4.4a3.19,3.19,0,0,1-1.56,2.1l-5,2.38A2.57,2.57,0,0,0,157.31,99v7.39a1.12,1.12,0,0,0,.51,1c.25.14,10.43,6,10.74,6.22l.07,0A1.1,1.1,0,0,1,168.05,112.63Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.72,59.93,181,53.7h0a1.24,1.24,0,0,0-1.51.27l-5.72,5.94a2.19,2.19,0,0,0-.54,1.17l10.75,6.22a2.12,2.12,0,0,1,.54-1.17l5.48-5.7A1.79,1.79,0,0,1,191.72,59.93Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7,48.88h0c-.26-.15-10.45-6.06-10.75-6.22a1.13,1.13,0,0,0-1,0l-6.19,2.31a2.38,2.38,0,0,0-.84.59l10.75,6.22a2.35,2.35,0,0,1,.83-.59l6.19-2.31A1.13,1.13,0,0,1,210.7,48.88Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,45.51a2.52,2.52,0,0,0-.66,1.41l-.39,5.25a3.08,3.08,0,0,1-.23.94l10.75,6.22a3.07,3.07,0,0,0,.22-.94l.39-5.25a2.47,2.47,0,0,1,.67-1.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,53.11a2.23,2.23,0,0,1-.78,1.07c-.3.18-.6.36-.89.56-1,.61-1.89,1.27-2.81,2l5.54,3.2h0a1.24,1.24,0,0,1,.39.34l2.24,2.84a1.45,1.45,0,0,0,2.06.23c1.09-.86,2.2-1.66,3.32-2.38.3-.2.59-.38.89-.56a2.31,2.31,0,0,0,.79-1.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.09,68.54a2.07,2.07,0,0,1-.15-1.24l-10.75-6.22a2.24,2.24,0,0,0,.15,1.24l1.85,3.89a2.53,2.53,0,0,1,.21,1l10.74,6.22a2.53,2.53,0,0,0-.2-1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,68.76c-.93,1.37-1.83,2.8-2.67,4.27a2.2,2.2,0,0,1-1,.86l10.74,6.22a2.17,2.17,0,0,0,1-.86c.84-1.47,1.73-2.9,2.67-4.27a2.8,2.8,0,0,0,.42-1.54h0L175.4,67.22A2.8,2.8,0,0,1,175,68.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12,74.08l-3.94-.65a2,2,0,0,0-1.24.26l10.74,6.22a2,2,0,0,1,1.24-.26l4,.65a2.05,2.05,0,0,0,1.18-.19l-10.74-6.22A2.07,2.07,0,0,1,170.12,74.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.94,73.69a1.87,1.87,0,0,0-.8.87l-3.33,7.91a1.52,1.52,0,0,0,.6,1.87l4.71,2.72,5.89,3.4h0a1.48,1.48,0,0,1-.47-1.76l3.33-7.91a1.92,1.92,0,0,1,.8-.87Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.12,87.06a1.74,1.74,0,0,1,0,1c-.38,1.47-.7,2.94-.95,4.4a3,3,0,0,1-.57,1.24l10.74,6.22a3,3,0,0,0,.58-1.24c.24-1.46.56-2.93.94-4.4a1.77,1.77,0,0,0-1-2l-3.6-1.57a2,2,0,0,1-.31-.19h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.64,93.66a2.85,2.85,0,0,1-1,.86l-5,2.38a2.52,2.52,0,0,0-1,1l10.75,6.22a2.41,2.41,0,0,1,1-1l5-2.38a2.85,2.85,0,0,0,1-.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.63,113.66a1.1,1.1,0,0,1-.58-1v-7.39a2.3,2.3,0,0,1,.31-1.08l-10.75-6.22a2.26,2.26,0,0,0-.3,1.08v7.39a1.12,1.12,0,0,0,.51,1c.25.14,10.43,6,10.74,6.22Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.16,76.15a.08.08,0,0,1,0,0,1.55,1.55,0,0,0-.07-.23l0,0a.62.62,0,0,0-.12-.19l0,0a1.06,1.06,0,0,0-.15-.15h0a1.15,1.15,0,0,0-1-.15l-4.88,1.33a1.32,1.32,0,0,1-1.67-1.08,33,33,0,0,0-.8-3.26,2.77,2.77,0,0,1-.09-1h0a2.91,2.91,0,0,1,0-.31s0,0,0-.06l.06-.26a1.85,1.85,0,0,0,.12-.31l.08-.16.06-.12a2.7,2.7,0,0,1,.18-.25l4.42-5.23a1.81,1.81,0,0,0,.31-.54,2.22,2.22,0,0,0,.14-1,1.93,1.93,0,0,0-.27-.89L240,59.77l-1.47-2.38h0a1.77,1.77,0,0,0-.16-.22l0,0a1.19,1.19,0,0,0-.18-.15l0,0a1.19,1.19,0,0,0-1.46.16l-4.76,4.34a1.61,1.61,0,0,1-2.15,0,19.72,19.72,0,0,0-2-1.6,2.06,2.06,0,0,1-.74-2.22l.35-1h0l.71-2,1.15-3.29a2.68,2.68,0,0,0,.07-.27v-.08a1.21,1.21,0,0,0,0-.19.28.28,0,0,0,0-.09.51.51,0,0,0,0-.17.29.29,0,0,0,0-.09l-.06-.16a.3.3,0,0,1,0-.08.94.94,0,0,0-.12-.18l0,0-.18-.19-.06,0a1.31,1.31,0,0,0-.47-.24L223.44,48a1.82,1.82,0,0,0-2.08.91l-2.85,5.75a2.18,2.18,0,0,1-1.87,1.23c-.4,0-.81,0-1.22,0-.74,0-1.49,0-2.23.11a1.43,1.43,0,0,1-1.59-1.3l-.19-2.43h0v-.12l-.18-2.36h0a1.36,1.36,0,0,0-.06-.29l0-.08c0-.06,0-.12-.08-.17s0-.05-.06-.08L210.9,49l-.08-.07-.12-.09a1.13,1.13,0,0,0-1-.05l-6.19,2.31a2.52,2.52,0,0,0-1.5,2l-.39,5.25a2.79,2.79,0,0,1-1,2c-.3.18-.59.36-.89.56-1.12.72-2.23,1.52-3.32,2.38a1.45,1.45,0,0,1-2.06-.23l-2.22-2.82a1.25,1.25,0,0,0-1.94-.1l-5.71,5.94a2.31,2.31,0,0,0-.39,2.41l1.85,3.89a2.84,2.84,0,0,1-.22,2.55c-.94,1.37-1.83,2.8-2.67,4.27a2.28,2.28,0,0,1-2.18,1l-4-.65a2,2,0,0,0-2,1.13l-3.33,7.91a1.5,1.5,0,0,0,.78,2l3.6,1.57a1.77,1.77,0,0,1,1,2c-.38,1.47-.7,2.94-.94,4.4a3.17,3.17,0,0,1-1.57,2.1l-5,2.38a2.56,2.56,0,0,0-1.34,2.12v7.39a1.1,1.1,0,0,0,.58,1l.09,0,.14,0,.09,0h.26a1.28,1.28,0,0,0,.27,0l1.27-.34h0l3.49-.95a1.33,1.33,0,0,1,1.68,1.07,29.31,29.31,0,0,0,.84,3.32,3,3,0,0,1-.48,2.53l-4.35,5.14a2.17,2.17,0,0,0-.18,2.39l2.93,4.77a1.29,1.29,0,0,0,.61.53h0a1.41,1.41,0,0,0,.22.06h.3l.22,0,0,0,.18-.08.06,0a.8.8,0,0,0,.21-.15l4.73-4.31a1.62,1.62,0,0,1,2.16,0,18.52,18.52,0,0,0,2,1.59,2,2,0,0,1,.74,2.21l-2.21,6.32a1.39,1.39,0,0,0,.64,1.69l0,0a1.09,1.09,0,0,0,.25.1l2.46.72,2.47.72a1.33,1.33,0,0,0,.3.06,1.5,1.5,0,0,0,.3,0,2,2,0,0,0,.59-.15,2,2,0,0,0,.52-.33,1.6,1.6,0,0,0,.36-.49l1.44-2.91,1.44-2.91h0a2.38,2.38,0,0,1,.18-.3l.07-.09.16-.18.08-.09.19-.16.08-.06a1.65,1.65,0,0,1,1-.36c.37,0,.75,0,1.13,0A23.51,23.51,0,0,0,200,133a1.4,1.4,0,0,1,1.58,1.29l.4,5a1.08,1.08,0,0,0,.63,1l.09,0,.15,0H203a1.08,1.08,0,0,0,.18,0h.09a1.34,1.34,0,0,0,.27-.07l6.19-2.31a2.54,2.54,0,0,0,.55-.32,3.05,3.05,0,0,0,.47-.48,2.82,2.82,0,0,0,.18-.29,2.08,2.08,0,0,0,.3-.91l.4-5.42a4.1,4.1,0,0,1,.11-.61,3.29,3.29,0,0,1,.35-.83,1.57,1.57,0,0,1,.48-.53l.82-.51.78-.51.3-.21.46-.32.38-.28.36-.27c.15-.1.29-.21.43-.32l.65-.5a1.45,1.45,0,0,1,2.06.22l2.31,2.94a1.28,1.28,0,0,0,.42.36l.06,0,.17.07.08,0,.17,0h.07a.87.87,0,0,0,.23,0h0a.7.7,0,0,0,.19-.06l.07,0,.16-.08.07,0a1.06,1.06,0,0,0,.2-.17l5.72-5.94a2,2,0,0,0,.46-.83,2.39,2.39,0,0,0,.11-.65,2.06,2.06,0,0,0-.18-.93l-1.93-4.06a2,2,0,0,1-.18-.61,3.17,3.17,0,0,1,0-.69,3.07,3.07,0,0,1,.14-.67,2.23,2.23,0,0,1,.28-.58c.45-.66.89-1.34,1.32-2s.85-1.38,1.26-2.09a2.27,2.27,0,0,1,1.87-1.08,1.56,1.56,0,0,1,.31,0l4.11.68.31,0a1.88,1.88,0,0,0,.89-.26,1.74,1.74,0,0,0,.38-.27,1.69,1.69,0,0,0,.31-.35,1.82,1.82,0,0,0,.15-.27l3.33-7.91a1.5,1.5,0,0,0,0-1.14,1.48,1.48,0,0,0-.79-.82l-3.74-1.63a1.74,1.74,0,0,1-.94-1.08h0v0s0,0,0-.07a1.55,1.55,0,0,1,0-.21.28.28,0,0,1,0-.09,1.21,1.21,0,0,1,0-.19.28.28,0,0,1,0-.09,1.26,1.26,0,0,1,0-.27h0c.09-.36.18-.72.26-1.07.17-.71.33-1.43.47-2.14.07-.35.13-.7.19-1.06,0-.1,0-.2.08-.31a3.28,3.28,0,0,1,1.49-1.79l2.58-1.22,2.59-1.23a2.46,2.46,0,0,0,.94-.88,2.44,2.44,0,0,0,.39-1.24V76.41A2.11,2.11,0,0,0,245.16,76.15ZM221.82,101c-.29.59-.78,1.54-1.09,2.12a37,37,0,0,1-11.86,13.34,17.45,17.45,0,0,1-9.39,3.13,10.76,10.76,0,0,1-7.8-3.17h0c-.16-.16-.31-.31-.45-.48h0a13.55,13.55,0,0,1-2.48-4.15.36.36,0,0,1,0-.09l-.21-.58-.06-.17-.16-.52-.06-.22-.14-.5-.06-.26c0-.16-.07-.32-.11-.49l-.06-.27-.09-.5c0-.09,0-.19,0-.29s-.05-.34-.08-.51,0-.19,0-.29,0-.37-.05-.56l0-.26c0-.27,0-.55,0-.84A37.51,37.51,0,0,1,192,87a37.5,37.5,0,0,1,12.41-14.39,17.5,17.5,0,0,1,9.39-3.13q.36,0,.72,0h.19l.53.05.19,0,.55.08.13,0q.33.06.66.15h0c5.25,1.38,8.71,6.48,9.06,13.77A37.05,37.05,0,0,1,221.82,101Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,83.6a17.92,17.92,0,0,0-2.7-9.1,10.85,10.85,0,0,0-6.36-4.67q-.33-.09-.66-.15l-.13,0-.55-.08-.19,0-.53-.05h-.19q-.36,0-.72,0l-.71,0a19,19,0,0,1,2,7.91,36.93,36.93,0,0,1-4,17.4c-.28.59-.77,1.54-1.09,2.12a37,37,0,0,1-11.85,13.34,18,18,0,0,1-8.68,3.11,13,13,0,0,0,1.77,2.59l.45.48a10.78,10.78,0,0,0,7.81,3.17,17.5,17.5,0,0,0,9.39-3.13,37,37,0,0,0,11.86-13.34c.31-.58.8-1.53,1.09-2.12A37.05,37.05,0,0,0,225.78,83.6Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,83.6a17.92,17.92,0,0,0-2.7-9.1,10.85,10.85,0,0,0-6.36-4.67q-.33-.09-.66-.15l-.13,0-.55-.08-.19,0-.53-.05h-.19q-.36,0-.72,0l-.71,0a19,19,0,0,1,2,7.91,36.93,36.93,0,0,1-4,17.4c-.28.59-.77,1.54-1.09,2.12a37,37,0,0,1-11.85,13.34,18,18,0,0,1-8.68,3.11,13,13,0,0,0,1.77,2.59l.45.48a10.78,10.78,0,0,0,7.81,3.17,17.5,17.5,0,0,0,9.39-3.13,37,37,0,0,0,11.86-13.34c.31-.58.8-1.53,1.09-2.12A37.05,37.05,0,0,0,225.78,83.6Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock-gear--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.16,116.79c5.36,5.37,8.67,13.62,9.17,23.87.57,11.75-2.48,25.1-8.61,37.83-.62,1.29-1.68,3.35-2.37,4.61-6.79,12.39-15.87,22.63-25.77,29-7,4.51-13.87,6.79-20.42,6.79a25.58,25.58,0,0,1-6.46-.81,23.41,23.41,0,0,0,17,6.88c6.55,0,13.42-2.28,20.42-6.79,9.9-6.38,19-16.62,25.78-29,.68-1.26,1.74-3.32,2.36-4.61,6.14-12.73,9.19-26.08,8.61-37.83C137.08,130.88,129.56,119.79,118.16,116.79Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.16,116.79c5.36,5.37,8.67,13.62,9.17,23.87.57,11.75-2.48,25.1-8.61,37.83-.62,1.29-1.68,3.35-2.37,4.61-6.79,12.39-15.87,22.63-25.77,29-7,4.51-13.87,6.79-20.42,6.79a25.58,25.58,0,0,1-6.46-.81,23.41,23.41,0,0,0,17,6.88c6.55,0,13.42-2.28,20.42-6.79,9.9-6.38,19-16.62,25.78-29,.68-1.26,1.74-3.32,2.36-4.61,6.14-12.73,9.19-26.08,8.61-37.83C137.08,130.88,129.56,119.79,118.16,116.79Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.56,123.24h0l-.06,0h0l-11.07-6.41h0l-.09,0h0c-7-3.54-16.29-2.5-26.32,4-20.15,13-35.55,42.91-34.39,66.85.58,11.93,5.17,20.12,12.12,23.73h0l.06,0h0l11.08,6.42h0l.08,0h0c7,3.55,16.3,2.51,26.34-3.95,20.15-13,35.55-42.91,34.38-66.85C132.09,135,127.51,126.85,120.56,123.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.36,217.47,60.8,211.32h0l-.07,0c-6.94-3.62-11.53-11.81-12.11-23.73C48.1,176.88,50.88,165,55.89,154L67,160.42c-5,11-7.8,22.87-7.28,33.55C60.26,205.65,64.66,213.74,71.36,217.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.18,
    cy: 170.48,
    rx: 53.16,
    ry: 30.69,
    transform: "translate(-99.41 178.03) rotate(-62.78)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4,212.16c-11.88.57-13.81-12.79-14.09-18.56-1-21.11,13.12-48.62,30.89-60.07,4.53-2.91,8.94-4.55,12.77-4.74,11.88-.57,13.81,12.79,14.09,18.56,1,21.11-13.12,48.62-30.9,60.07-4.52,2.91-8.93,4.55-12.76,4.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.52,174.43a1.2,1.2,0,0,1-.42-.07,1.28,1.28,0,0,1-.88-1.22V142.59a1.3,1.3,0,1,1,2.59,0v26.78l14.25-18.3a1.29,1.29,0,0,1,2,1.59L99.54,173.94A1.29,1.29,0,0,1,98.52,174.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.22,197a.57.57,0,0,1-.18,0,.54.54,0,0,1-.37-.67l7.17-24.17a.55.55,0,0,1,.68-.36.54.54,0,0,1,.36.67l-7.16,24.17A.58.58,0,0,1,91.22,197Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,167c2.37-1.53,4.4-.48,4.54,2.34a9.81,9.81,0,0,1-4.05,7.86c-2.37,1.53-4.4.48-4.54-2.34A9.78,9.78,0,0,1,98.11,167Z",
    style: {
      fill: "#54BDC1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,138.36a.13.13,0,0,0,0-.06,1.63,1.63,0,0,0-.13-.39l0-.07a1.38,1.38,0,0,0-.2-.33l0,0a2.23,2.23,0,0,0-.27-.26l0,0a2,2,0,0,0-1.76-.27l-8.53,2.32a2.31,2.31,0,0,1-2.92-1.87,55.84,55.84,0,0,0-1.41-5.7,5,5,0,0,1-.14-1.84v0a3.2,3.2,0,0,1,.08-.54.36.36,0,0,1,0-.11c0-.15.07-.31.12-.45s.05-.13.07-.2.08-.23.13-.34a2.44,2.44,0,0,1,.14-.28c0-.07.07-.15.11-.22a4.73,4.73,0,0,1,.31-.43l7.73-9.14a3.24,3.24,0,0,0,.54-.94,4,4,0,0,0,.24-1.67,3.32,3.32,0,0,0-.47-1.57l-2.56-4.17L152,105.58h0a2.63,2.63,0,0,0-.29-.37l0,0a2.69,2.69,0,0,0-.32-.27l-.07,0a2,2,0,0,0-2.55.28l-8.32,7.58a2.78,2.78,0,0,1-3.75-.07,37.42,37.42,0,0,0-3.41-2.79,3.58,3.58,0,0,1-1.3-3.88l.62-1.76h0l1.24-3.53,2-5.75a2.08,2.08,0,0,0,.11-.48s0-.1,0-.15,0-.21,0-.31,0-.12,0-.17a2.5,2.5,0,0,0-.05-.29c0-.06,0-.11,0-.16a2.33,2.33,0,0,0-.11-.28l-.06-.14a2.11,2.11,0,0,0-.21-.31.25.25,0,0,0,0-.07,3.22,3.22,0,0,0-.32-.32l-.11-.08a2.38,2.38,0,0,0-.81-.41l-8.6-2.52A3.18,3.18,0,0,0,122,90.82l-5,10.06A3.86,3.86,0,0,1,113.7,103c-.7,0-1.41-.06-2.12-.06-1.3,0-2.61.06-3.91.18a2.46,2.46,0,0,1-2.77-2.26l-.34-4.24h0v-.21l-.33-4.13h0a2.71,2.71,0,0,0-.09-.51l-.07-.15a1.48,1.48,0,0,0-.12-.29.76.76,0,0,0-.11-.14,1.16,1.16,0,0,0-.16-.21,1.58,1.58,0,0,0-.15-.12.9.9,0,0,0-.19-.15,2,2,0,0,0-1.73-.1L90.77,94.68a4.39,4.39,0,0,0-2.61,3.48l-.68,9.18a4.91,4.91,0,0,1-1.78,3.51l-1.55,1q-3,1.91-5.8,4.16a2.54,2.54,0,0,1-3.6-.39l-3.88-4.94a2.19,2.19,0,0,0-3.39-.17l-10,10.39a4,4,0,0,0-.69,4.2L60,131.88a4.9,4.9,0,0,1-.38,4.45q-2.46,3.6-4.66,7.45a4,4,0,0,1-3.82,1.85l-6.89-1.13a3.46,3.46,0,0,0-3.56,2l-5.82,13.83a2.62,2.62,0,0,0,1.36,3.42l6.3,2.74A3.1,3.1,0,0,1,44.26,170q-1,3.87-1.66,7.7a5.53,5.53,0,0,1-2.73,3.67l-8.74,4.15a4.49,4.49,0,0,0-2.34,3.7v12.92a1.93,1.93,0,0,0,1,1.8L30,204l.24.07.16,0a1.51,1.51,0,0,0,.3,0h.15a2.09,2.09,0,0,0,.48-.08l2.21-.6h0l6.1-1.66a2.32,2.32,0,0,1,2.94,1.87,55.24,55.24,0,0,0,1.46,5.8,5.16,5.16,0,0,1-.83,4.42l-7.6,9a3.81,3.81,0,0,0-.31,4.18l5.12,8.34a2.2,2.2,0,0,0,1.06.91l0,0a1.86,1.86,0,0,0,.39.1l.11,0a1.61,1.61,0,0,0,.31,0h.1a3.14,3.14,0,0,0,.4-.08l.08,0a2.2,2.2,0,0,0,.31-.15l.11-.06a3.18,3.18,0,0,0,.37-.27l8.26-7.53a2.82,2.82,0,0,1,3.77.06,36.25,36.25,0,0,0,3.44,2.77A3.57,3.57,0,0,1,60.43,235l-3.87,11a2.42,2.42,0,0,0,1.12,3l.06,0a1.77,1.77,0,0,0,.45.18l4.3,1.26,4.3,1.26a2.39,2.39,0,0,0,.52.1,2.44,2.44,0,0,0,.54,0,3.39,3.39,0,0,0,1-.26,3.16,3.16,0,0,0,.9-.58,3,3,0,0,0,.64-.85l2.52-5.08L75.46,240h0a3.55,3.55,0,0,1,.32-.53l.11-.15.29-.33a.93.93,0,0,1,.14-.14l.33-.29.13-.1a3,3,0,0,1,1.8-.63c.65,0,1.31.05,2,.05a41,41,0,0,0,4.14-.21,2.47,2.47,0,0,1,2.77,2.25l.69,8.76a1.88,1.88,0,0,0,1.1,1.68l.16.07.26.05.17,0,.3,0h.15a2.85,2.85,0,0,0,.48-.13l10.83-4a3.4,3.4,0,0,0,1-.55,5,5,0,0,0,.82-.84c.11-.16.22-.33.32-.5a3.87,3.87,0,0,0,.52-1.59l.7-9.48a6.67,6.67,0,0,1,.19-1.07,6.06,6.06,0,0,1,.61-1.44,2.71,2.71,0,0,1,.84-.92L108,229l1.36-.91.53-.36.8-.56.67-.49.63-.46.75-.57,1.14-.88a2.54,2.54,0,0,1,3.6.39l4,5.15a2.33,2.33,0,0,0,.74.63l.1,0,.29.11.14,0,.3.05h.11a2,2,0,0,0,.42,0l.08,0,.33-.1.13-.05.28-.15.11-.08a2,2,0,0,0,.36-.3l10-10.39a3.6,3.6,0,0,0,.82-1.44,4.38,4.38,0,0,0,.18-1.14,3.5,3.5,0,0,0-.31-1.62l-3.37-7.09a3.75,3.75,0,0,1-.31-1.08,4.72,4.72,0,0,1,0-1.19,5,5,0,0,1,.23-1.18,3.64,3.64,0,0,1,.49-1c.79-1.16,1.56-2.34,2.31-3.55s1.49-2.42,2.2-3.66a4,4,0,0,1,3.27-1.88,2.37,2.37,0,0,1,.54,0l7.19,1.17a3.08,3.08,0,0,0,.53,0,3.5,3.5,0,0,0,1.57-.44,3.14,3.14,0,0,0,.66-.49,3.06,3.06,0,0,0,.54-.6,3.1,3.1,0,0,0,.26-.47l5.82-13.83a2.62,2.62,0,0,0-1.37-3.42l-6.54-2.85a3.06,3.06,0,0,1-1.63-1.89h0s0,0,0,0,0-.08,0-.12a2.17,2.17,0,0,1-.07-.35,1,1,0,0,1,0-.16c0-.12,0-.23,0-.35a.66.66,0,0,1,0-.14,2.65,2.65,0,0,1,.07-.48h0c.16-.63.32-1.25.47-1.87.29-1.25.56-2.49.81-3.73.12-.62.23-1.24.34-1.86a3.53,3.53,0,0,1,.13-.54,5.69,5.69,0,0,1,2.61-3.13l4.51-2.14,4.51-2.14a4.52,4.52,0,0,0,2.34-3.7V138.83A2.34,2.34,0,0,0,163.53,138.36Zm-34.3,46.2c-.62,1.29-1.68,3.35-2.36,4.61-6.8,12.39-15.88,22.63-25.78,29-7,4.51-13.87,6.79-20.42,6.79a23.41,23.41,0,0,1-17-6.88h0c-.33-.34-.66-.69-1-1h0a29.61,29.61,0,0,1-5.41-9c0-.06-.05-.13-.08-.2q-.24-.62-.45-1.26c-.05-.12-.09-.25-.13-.37l-.36-1.14c0-.16-.09-.32-.13-.48-.1-.36-.2-.72-.29-1.09,0-.18-.09-.36-.14-.55l-.24-1.06-.12-.61c-.07-.35-.13-.71-.19-1.07,0-.21-.08-.42-.11-.63-.06-.37-.11-.73-.16-1.11,0-.21-.06-.42-.08-.63,0-.4-.09-.81-.13-1.22,0-.19,0-.37-.05-.56,0-.6-.1-1.21-.13-1.82-.6-12.48,2.87-26.74,9.77-40.16s16.49-24.54,27-31.3c7-4.5,13.87-6.79,20.42-6.79.52,0,1,0,1.56,0l.41,0c.39,0,.78.06,1.16.11l.4,0,1.2.19.28.06c.49.09,1,.2,1.45.32h0c11.4,3,18.92,14.09,19.68,29.94C138.42,158.48,135.37,171.83,129.23,184.56Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,131.67a55.84,55.84,0,0,1,1.41,5.7,2.31,2.31,0,0,0,2.92,1.87l8.53-2.32a2,2,0,0,1,1.54.13h0c-.42-.23-9.92-5.74-10.5-6.06a2,2,0,0,0-1.55-.14l-2.38.65h0S148.21,131.61,148.22,131.67Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,131.67a55.84,55.84,0,0,1,1.41,5.7,2.31,2.31,0,0,0,2.92,1.87l8.53-2.32a2,2,0,0,1,1.54.13h0c-.42-.23-9.92-5.74-10.5-6.06a2,2,0,0,0-1.55-.14l-2.38.65h0S148.21,131.61,148.22,131.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24,109.84a37.42,37.42,0,0,1,3.41,2.79,2.78,2.78,0,0,0,3.75.07l8.32-7.58a2,2,0,0,1,2.55-.28l-.08,0-10.53-6.08a2.07,2.07,0,0,0-2.45.34l-5.65,5.15-.62,1.76A3.58,3.58,0,0,0,133.24,109.84Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24,109.84a37.42,37.42,0,0,1,3.41,2.79,2.78,2.78,0,0,0,3.75.07l8.32-7.58a2,2,0,0,1,2.55-.28l-.08,0-10.53-6.08a2.07,2.07,0,0,0-2.45.34l-5.65,5.15-.62,1.76A3.58,3.58,0,0,0,133.24,109.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,246l3.87-11a3.57,3.57,0,0,0-1.31-3.87,36.25,36.25,0,0,1-3.44-2.77,2.82,2.82,0,0,0-3.77-.06l-2.61,2.38L46.05,240a2.43,2.43,0,0,0,1.08,2.95c.17.09,9.5,5.49,10.51,6.06l0,0A2.42,2.42,0,0,1,56.56,246Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,246l3.87-11a3.57,3.57,0,0,0-1.31-3.87,36.25,36.25,0,0,1-3.44-2.77,2.82,2.82,0,0,0-3.77-.06l-2.61,2.38L46.05,240a2.43,2.43,0,0,0,1.08,2.95c.17.09,9.5,5.49,10.51,6.06l0,0A2.42,2.42,0,0,1,56.56,246Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.15,248.64l-.69-8.76a2.47,2.47,0,0,0-2.77-2.25,41,41,0,0,1-4.14.21c-.66,0-1.32,0-2-.05a3,3,0,0,0-1.8.63,4.53,4.53,0,0,1,.5-.31l.35,4.46a2,2,0,0,0,.86,1.56c.47.31,10.07,5.82,10.58,6.12l.18.07A1.88,1.88,0,0,1,88.15,248.64Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.15,248.64l-.69-8.76a2.47,2.47,0,0,0-2.77-2.25,41,41,0,0,1-4.14.21c-.66,0-1.32,0-2-.05a3,3,0,0,0-1.8.63,4.53,4.53,0,0,1,.5-.31l.35,4.46a2,2,0,0,0,.86,1.56c.47.31,10.07,5.82,10.58,6.12l.18.07A1.88,1.88,0,0,1,88.15,248.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5,230.3l-4-5.15a2.54,2.54,0,0,0-3.6-.39l-1.14.88.16-.11,9.32,5.38,0,0A2.33,2.33,0,0,1,121.5,230.3Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5,230.3l-4-5.15a2.54,2.54,0,0,0-3.6-.39l-1.14.88.16-.11,9.32,5.38,0,0A2.33,2.33,0,0,1,121.5,230.3Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.09,177.24l-8.17-4.74a3.06,3.06,0,0,0,1.63,1.89l6.54,2.85",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.09,177.24l-8.17-4.74a3.06,3.06,0,0,0,1.63,1.89l6.54,2.85",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.67,103.15c1.3-.12,2.61-.18,3.91-.18.71,0,1.42,0,2.12.06a3.86,3.86,0,0,0,3.27-2.15l5-10.06a3.18,3.18,0,0,1,3.63-1.59l8.6,2.52a2.38,2.38,0,0,1,.81.41l-.2-.15-10.56-6.1a2.53,2.53,0,0,0-.56-.23l-8.6-2.52a3.18,3.18,0,0,0-3.63,1.59l-5,10.06a4.18,4.18,0,0,1-1.9,1.84l.34,4.24A2.46,2.46,0,0,0,107.67,103.15Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,103a3.25,3.25,0,0,0,1.92-.64l-10.51-6.06a3.76,3.76,0,0,1-.55.32l.34,4.24a2.46,2.46,0,0,0,2.77,2.26c1.3-.12,2.61-.18,3.91-.18C112.29,103,113,103,113.7,103Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,92.16l-.2-.15-10.56-6.1a2.53,2.53,0,0,0-.56-.23l-8.6-2.52a3.11,3.11,0,0,0-2.58.43L123,89.66a3.11,3.11,0,0,1,2.58-.43l8.6,2.52A2.38,2.38,0,0,1,135,92.16Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.48,83.59a2.91,2.91,0,0,0-1,1.16l-5,10.06a4,4,0,0,1-1.35,1.52l10.51,6.06a4,4,0,0,0,1.35-1.51l5-10.06a3,3,0,0,1,1-1.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.79,202.12V189.2a4.49,4.49,0,0,1,2.34-3.7l8.74-4.15a5.53,5.53,0,0,0,2.73-3.67q.66-3.83,1.66-7.7a3.1,3.1,0,0,0-1.69-3.53l-6.3-2.74a2.62,2.62,0,0,1-1.36-3.42l5.82-13.83a3.46,3.46,0,0,1,3.56-2l6.89,1.13A4,4,0,0,0,55,143.78q2.19-3.85,4.66-7.45a4.9,4.9,0,0,0,.38-4.45l-3.23-6.81a4,4,0,0,1,.69-4.2l10-10.39a2.19,2.19,0,0,1,3.39.17l3.88,4.94a2.54,2.54,0,0,0,3.6.39q2.85-2.25,5.8-4.16l1.55-1a4.91,4.91,0,0,0,1.78-3.51l.68-9.18a4.39,4.39,0,0,1,2.61-3.48l10.83-4.05a2,2,0,0,1,1.73.1l0,0c-.47-.26-10-5.79-10.52-6.08a2,2,0,0,0-1.69-.06l-10.82,4a4.37,4.37,0,0,0-2.61,3.48L77,101.27a4.87,4.87,0,0,1-1.77,3.51c-.52.31-1,.64-1.55,1q-2.49,1.6-4.91,3.46s-8.84-5.12-9.12-5.26a2.17,2.17,0,0,0-2.64.46L47,114.8a4,4,0,0,0-.68,4.2l3.23,6.81a4.94,4.94,0,0,1-.38,4.45q-2.46,3.6-4.67,7.45a4,4,0,0,1-3.81,1.85l-6.89-1.13a3.45,3.45,0,0,0-3.56,2l-5.83,13.83a2.64,2.64,0,0,0,1.06,3.26l8.23,4.75a3,3,0,0,1,.07,1.68q-1,3.87-1.66,7.7a5.54,5.54,0,0,1-2.74,3.67l-8.74,4.16a4.45,4.45,0,0,0-2.33,3.69v12.92a2,2,0,0,0,.9,1.75l10.5,6.06.12.06A1.93,1.93,0,0,1,28.79,202.12Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.33,90.73l0,0c-.47-.26-10-5.79-10.52-6.08a2,2,0,0,0-1.69-.06l-10.82,4a4.08,4.08,0,0,0-1.46,1L89.32,95.7a4,4,0,0,1,1.45-1l10.83-4.05A2,2,0,0,1,103.33,90.73Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,89.63a4.25,4.25,0,0,0-1.15,2.46L77,101.27a5.53,5.53,0,0,1-.39,1.64L87.08,109a5.55,5.55,0,0,0,.4-1.64l.68-9.18a4.27,4.27,0,0,1,1.16-2.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.57,102.91a4,4,0,0,1-1.38,1.87c-.52.31-1,.64-1.55,1q-2.49,1.6-4.9,3.46l1.44.84h0a2.26,2.26,0,0,1,.69.59l3.88,4.94a2.54,2.54,0,0,0,3.6.39q2.85-2.25,5.8-4.16l1.55-1A3.94,3.94,0,0,0,87.08,109Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.07,110l-10.45-6h0a2.17,2.17,0,0,0-2.64.46L47,114.8a3.75,3.75,0,0,0-.94,2l10.51,6.07a3.76,3.76,0,0,1,1-2l10-10.39A2.18,2.18,0,0,1,70.07,110Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.81,125.07a3.71,3.71,0,0,1-.26-2.15L46,116.85A3.71,3.71,0,0,0,46.3,119l3.23,6.81a4.2,4.2,0,0,1,.36,1.76l10.51,6.07a4,4,0,0,0-.36-1.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.15,130.26q-2.46,3.6-4.67,7.45a3.9,3.9,0,0,1-1.73,1.52l10.51,6.07A3.92,3.92,0,0,0,55,143.78q2.19-3.85,4.66-7.45a4.81,4.81,0,0,0,.74-2.69h0l-10.51-6.07A4.81,4.81,0,0,1,49.15,130.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.67,139.56l-6.89-1.13a3.3,3.3,0,0,0-2.16.44l10.51,6.07a3.31,3.31,0,0,1,2.16-.44l6.89,1.13a3.71,3.71,0,0,0,2.08-.33l-10.51-6.07A3.71,3.71,0,0,1,40.67,139.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.62,138.87a3.31,3.31,0,0,0-1.4,1.52l-5.83,13.83a2.64,2.64,0,0,0,1.06,3.26l8.23,4.75,2,1.15h0a2.62,2.62,0,0,1-.81-3.08l5.82-13.83a3.31,3.31,0,0,1,1.4-1.52Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.68,162.23a3,3,0,0,1,.07,1.68q-1,3.87-1.66,7.7a5.1,5.1,0,0,1-1,2.16l10.51,6.07a5.1,5.1,0,0,0,1-2.16q.66-3.83,1.66-7.7a3.1,3.1,0,0,0-1.69-3.53l-6.3-2.74a2.69,2.69,0,0,1-.54-.33h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.09,173.77a4.94,4.94,0,0,1-1.74,1.51l-8.74,4.16a4.25,4.25,0,0,0-1.8,1.81l10.51,6.07a4.35,4.35,0,0,1,1.81-1.82l8.74-4.15a5,5,0,0,0,1.73-1.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,203.92a1.93,1.93,0,0,1-1-1.8V189.2a4.11,4.11,0,0,1,.53-1.88l-10.51-6.07a4,4,0,0,0-.53,1.88v12.92a2,2,0,0,0,.9,1.75l10.5,6.06Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.38,235.37,35.26,227a3.81,3.81,0,0,1,.31-4.18l7.6-9a5.16,5.16,0,0,0,.83-4.42,55.24,55.24,0,0,1-1.46-5.8,2.32,2.32,0,0,0-2.94-1.87l-6.1,1.66a5.16,5.16,0,0,1-.85,4.36l-7.59,9a3.83,3.83,0,0,0-.32,4.18l5.13,8.34a2.29,2.29,0,0,0,.83.81c.76.42,10.18,5.88,10.49,6.06l.25.11A2.2,2.2,0,0,1,40.38,235.37Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,209.44a55.24,55.24,0,0,1-1.46-5.8,2.32,2.32,0,0,0-2.94-1.87l-6.1,1.66a5.32,5.32,0,0,1-.19,3.19l10.51,6.07A5.21,5.21,0,0,0,44,209.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.33,218.43l10.52,6.07a3.43,3.43,0,0,1,.72-1.65l7.6-9a3.89,3.89,0,0,0,.65-1.17l-10.51-6.07a3.71,3.71,0,0,1-.66,1.17l-7.59,9A3.54,3.54,0,0,0,24.33,218.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,236.17l.25.11a2.2,2.2,0,0,1-1.06-.91L35.26,227a3.65,3.65,0,0,1-.41-2.53l-10.52-6.07a3.76,3.76,0,0,0,.41,2.53l5.13,8.34a2.29,2.29,0,0,0,.83.81C31.46,230.53,40.88,236,41.19,236.17Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.28,345.85a10.5,10.5,0,0,0,4.9,8.14l106.73,61.64a10.87,10.87,0,0,0,9.81,0L426.66,307.12a9.2,9.2,0,0,0,0-16.28L319.93,229.2a10.85,10.85,0,0,0-9.8,0L122.18,337.71A10.5,10.5,0,0,0,117.28,345.85Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.57,299a10.54,10.54,0,0,1-4.9,8.14l-188,108.51a10.17,10.17,0,0,1-4.9,1.17V406.18a10.06,10.06,0,0,0,4.9-1.17l188-108.51c2.37-1.37,2.66-3.48.88-5A10.51,10.51,0,0,1,431.57,299Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18,343.37,228.91,405a10.87,10.87,0,0,0,9.81,0L426.66,296.5c2.71-1.57,2.71-4.1,0-5.66L319.93,229.2a10.85,10.85,0,0,0-9.8,0L122.18,337.71C119.47,339.27,119.47,341.81,122.18,343.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82,406.19V416.8a10,10,0,0,1-4.9-1.17L122.18,354a9.17,9.17,0,0,1-.5-16c-2.2,1.57-2,3.88.5,5.34L228.92,405A10,10,0,0,0,233.82,406.19Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,337.89c-2.54-1.47-2.4-3.95-2.4-7.07V183.39a10.84,10.84,0,0,1,4.91-8.49L303.12,66.39a10.54,10.54,0,0,1,9.5-.18c2.55,1.47,2.41,4,2.41,7.07V220.71a10.84,10.84,0,0,1-4.9,8.49L122.18,337.71A10.54,10.54,0,0,1,112.68,337.89Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,73.28c0-3.12-2.2-4.39-4.9-2.83L122.18,179a9.89,9.89,0,0,0-3.47,3.66l-7-4.07h0a10,10,0,0,1,3.47-3.66L303.12,66.39a10.51,10.51,0,0,1,9.5-.18C315.16,67.68,315,70.16,315,73.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.28,187.45V334.88c0,3.13,2.19,4.39,4.9,2.83l188-108.51a10.84,10.84,0,0,0,4.9-8.49V73.28c0-3.12-2.2-4.39-4.9-2.83L122.18,179A10.85,10.85,0,0,0,117.28,187.45Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,338a10.56,10.56,0,0,1-8.92-.13c-2.54-1.46-2.4-3.94-2.4-7.06V183.39a9.84,9.84,0,0,1,1.44-4.83l7,4.06h0a10.08,10.08,0,0,0-1.44,4.82V334.88C117.27,337.78,119.17,339.08,121.6,338Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82,184.62,306,80c1.62-.94,2.94-.18,2.94,1.7V210.42a6.48,6.48,0,0,1-2.94,5.09L124.82,320.1c-1.63.94-2.95.18-2.95-1.69V189.71A6.5,6.5,0,0,1,124.82,184.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,338,310.2,237.28a5.42,5.42,0,0,1,4.9,0l2.91,1.6c1.35.78,1.35,2,0,2.83L143.53,342.41a5.44,5.44,0,0,1-4.91,0l-2.88-1.58C134.39,340.05,134.39,338.78,135.74,338Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,346.14,323.88,245.42a5,5,0,0,1,4.48-.25l45.41,26.22c1.12.65.93,1.8-.43,2.58L199.09,374.56a5,5,0,0,1-4.48.25L149,348.72C147.89,348.07,148.07,346.92,149.43,346.14Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.59,287.72l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3A.88.88,0,0,0,300.59,287.72Zm-8-10.91L287.16,280c-.24.14-.26.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.85.85,0,0,0,292.62,276.81ZM275,287l-9.24,5.33c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l9.24-5.33c.24-.14.26-.34.05-.46l-5.22-3A.87.87,0,0,0,275,287Zm9.67-5.58-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3A.85.85,0,0,0,284.64,281.42Zm-21.43,12.37-5.46,3.15c-.24.14-.26.34-.05.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.88.88,0,0,0,263.21,293.79Zm-8,4.61-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3A.87.87,0,0,0,255.22,298.4Zm20.49,12.31,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3A.9.9,0,0,0,275.71,310.71Zm-8,4.61,5.47-3.16c.23-.13.25-.33,0-.45l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.92.92,0,0,0,267.72,315.32Zm-8,4.61,5.46-3.16c.23-.13.26-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,259.74,319.93Zm-8,4.61,5.46-3.16c.23-.13.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.46l5.22,3A.9.9,0,0,0,251.76,324.54Zm40.85-32.21,5.46-3.15c.23-.14.26-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.88.88,0,0,0,292.61,292.33Zm-8.92,13.77,12.18-7c.24-.14.26-.34.05-.46l-12.69-7.33a.85.85,0,0,0-.79,0L276.13,295c-.23.13-.25.33,0,.45l6.72,3.88c.2.12.18.33-.05.46l-5,2.91c-.23.14-.26.34-.05.46l5.23,3A.88.88,0,0,0,283.69,306.1ZM247.24,303l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34,0-.46L248,303A.85.85,0,0,0,247.24,303Zm-8,4.61-5.46,3.15c-.24.13-.26.34-.05.46l5.22,3a.94.94,0,0,0,.8,0l5.46-3.16c.23-.13.25-.33.05-.45l-5.23-3A.85.85,0,0,0,239.26,307.62Zm-44.18,49.21a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46Zm-19.69-12.34-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34,0-.46l-5.22-3A.9.9,0,0,0,175.39,344.49Zm10.13,9.24a.85.85,0,0,0,.79,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46Zm22,4.95,5.46-3.15c.24-.13.26-.34.05-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.45l5.23,3A.85.85,0,0,0,207.54,358.68Zm-8.77,4.64a.85.85,0,0,0,.79,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.33-.05.45Zm-15.39-23.44L177.91,343c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3A.88.88,0,0,0,183.38,339.88Zm39.91-23.05L217.83,320c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.23-3A.88.88,0,0,0,223.29,316.83Zm-31.93,18.44-5.46,3.15c-.24.14-.26.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3A.92.92,0,0,0,191.36,335.27Zm39.91-23-5.46,3.15c-.23.13-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.45l-5.22-3A.87.87,0,0,0,231.27,312.23Zm-16,9.21-5.46,3.16c-.24.13-.26.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,215.31,321.44Zm-8,4.61-5.47,3.16c-.23.13-.25.34,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.22-3A.88.88,0,0,0,207.33,326.05Zm-8,4.61-5.46,3.16c-.23.13-.25.33,0,.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-5.22-3A.9.9,0,0,0,199.34,330.66Zm36.45,3.09,5.46-3.15c.23-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34,0,.45l5.23,3A.85.85,0,0,0,235.79,333.75Zm74.48-67.13-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3A.88.88,0,0,0,310.27,266.62Zm-9.67,5.58-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.22-3A.9.9,0,0,0,300.6,272.2ZM318.25,262l-5.46,3.15c-.23.14-.26.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34,0-.46L319,262A.92.92,0,0,0,318.25,262Zm-44.13,41,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33,0,.45l5.23,3A.85.85,0,0,0,274.12,303ZM327,257.37a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33,0,.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46Zm-83.26,71.78,5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,243.77,329.15Zm97.9-56.53,5.46-3.15c.24-.13.26-.34.05-.46L342,266a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33-.05.45l5.23,3A.85.85,0,0,0,341.67,272.62Zm-15.45.3,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.85.85,0,0,0,326.22,272.92Zm8.27-11.24a.92.92,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.33,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46Zm1.68-1L348.86,268a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-12.7-7.32a.88.88,0,0,0-.79,0l-5.46,3.16C336,260.39,336,260.6,336.17,260.71Zm-18.44,10.22-5.46,3.15c-.23.14-.25.34,0,.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.23-3A.88.88,0,0,0,317.73,270.93Zm-60.08,34.69-5.46,3.15c-.24.14-.26.34-.05.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.88.88,0,0,0,257.65,305.62Zm75.25-28.36a.85.85,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.26.34-.05.46ZM265.63,301l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.14.26-.34,0-.46l-5.23-3A.88.88,0,0,0,265.63,301Zm-62.57,51.21a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34,0,.46Zm-9.28-9.73-5.46,3.16c-.23.13-.25.34,0,.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-5.22-3A.94.94,0,0,0,193.78,342.49Zm18.06,5.09,5.46-3.15c.24-.14.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.85.85,0,0,0,211.84,347.58Zm8-4.61,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3A.85.85,0,0,0,219.82,343Zm8-4.61,5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34-.05.45l5.22,3A.87.87,0,0,0,227.81,338.36Zm-26-.48L196.3,341c-.23.13-.25.34,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.22-3A.88.88,0,0,0,201.77,337.88Zm8-4.61-5.46,3.16c-.24.13-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,209.75,333.27Zm31.93-18.43L236.22,318c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34,0-.46l-5.23-3A.85.85,0,0,0,241.68,314.84Zm-8,4.61-5.46,3.15c-.24.13-.26.34-.05.46l5.22,3a.94.94,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.85.85,0,0,0,233.7,319.45Zm16-9.22-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3A.87.87,0,0,0,249.66,310.23Zm-31.93,18.43-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.23-3A.88.88,0,0,0,217.73,328.66Zm8-4.6-5.46,3.15c-.23.13-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.45l-5.22-3A.87.87,0,0,0,225.71,324.06Zm-10.19,30,5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.46l5.22,3A.88.88,0,0,0,215.52,354.08Zm-42.09-2-5.23-3a.85.85,0,0,0-.79,0L162,352.25c-.24.14-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15C173.61,352.41,173.63,352.21,173.43,352.09Zm10.4,2.61-5.22-3a.88.88,0,0,0-.79,0l-8.41,4.85c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l8.41-4.85C184,355,184,354.82,183.83,354.7Zm-18.2-8.57-5.23-3a.88.88,0,0,0-.79,0L152.89,347c-.23.13-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l6.72-3.88C165.81,346.45,165.83,346.25,165.63,346.13Zm5.15-3a.9.9,0,0,0,.8,0L177,340c.23-.13.25-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46ZM193.4,357.8l-5.22-3a.87.87,0,0,0-.8,0l-10.5,6.06c-.23.14-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l10.5-6.06C193.59,358.12,193.61,357.92,193.4,357.8Zm3.68,6.49-5.22-3a.88.88,0,0,0-.79,0l-6.73,3.88c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l6.73-3.88C197.27,364.61,197.29,364.41,197.08,364.29Zm33.06-55.4a.92.92,0,0,0,.79,0l5.46-3.16c.24-.13.26-.33.05-.45l-5.22-3a.87.87,0,0,0-.8,0L225,305.41c-.23.13-.25.34-.05.46Zm-16,9.21a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34,0-.46l-5.22-3a.88.88,0,0,0-.79,0L209,314.63c-.23.13-.25.34,0,.46Zm-35.4,20.44a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.33,0-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.26.34-.05.46Zm43.39-25.05a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0L217,310c-.24.13-.26.34,0,.46Zm-16,9.22a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.22-3a.9.9,0,0,0-.8,0L201,319.24c-.23.13-.25.34,0,.46ZM201,364.61a.88.88,0,0,0-.79,0l-8.4,4.85c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l8.4-4.85c.24-.14.26-.34,0-.46Zm-6.27-35.28a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46Zm-8,4.61a.92.92,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46ZM348.9,279.22a.92.92,0,0,0-.79,0L334.66,287c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l13.44-7.76c.23-.13.26-.34.05-.46Zm-17.64,10.19a.9.9,0,0,0-.8,0L325,292.59c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46ZM223.51,349.47l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0L217.54,346c-.24.13-.26.34,0,.46l5.22,3A.9.9,0,0,0,223.51,349.47Zm91.78-50.84a.85.85,0,0,0-.79,0L309,301.81c-.23.14-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46Zm41.6-24a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46ZM370.1,273l-12.7-7.32a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34,0,.45l12.69,7.33a.87.87,0,0,0,.8,0l5.46-3.15C370.28,273.35,370.3,273.14,370.1,273Zm-84.64,42.83a.9.9,0,0,0-.8,0l-6.72,3.88c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l6.73-3.88c.23-.13.25-.34,0-.46Zm20.17-11.64a.87.87,0,0,0-.8,0l-8.4,4.85c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l8.41-4.85c.23-.14.25-.34,0-.46ZM267,326.53a.88.88,0,0,0-.79,0l-45,26c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l45-26c.23-.13.25-.34.05-.46Zm-47.48,27.41a.85.85,0,0,0-.79,0L212,357.85c-.24.13-.26.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l6.72-3.89c.23-.13.25-.33.05-.45Zm56.72-32.75a.85.85,0,0,0-.79,0l-6.72,3.88c-.23.13-.26.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l6.72-3.88c.24-.14.26-.34.05-.46Zm-66,38.09a.9.9,0,0,0-.8,0l-6.72,3.88c-.23.14-.25.34,0,.46l5.22,3a.85.85,0,0,0,.79,0l6.73-3.88c.23-.13.25-.34,0-.46Zm84.45-48.76a.88.88,0,0,0-.79,0l-6.72,3.89c-.24.13-.26.33-.05.45l5.22,3a.87.87,0,0,0,.8,0l6.72-3.88c.23-.13.25-.34.05-.46ZM323.27,294a.85.85,0,0,0-.79,0L317,297.2c-.23.14-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46Zm17.88-12.48,5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3A.85.85,0,0,0,341.15,281.54Zm-32.57,1.57L314,280c.23-.14.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46l5.22,3A.87.87,0,0,0,308.58,283.11Zm-21.21,29.48,16-9.21c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-16,9.22c-.23.13-.25.33,0,.45l5.23,3A.85.85,0,0,0,287.37,312.59Zm45-26.41a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46Zm-6.67-4.34,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3A.87.87,0,0,0,325.71,281.84ZM279.39,317.2l5.46-3.15c.23-.14.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.85.85,0,0,0,279.39,317.2Zm35.34-20.83a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46Zm-75.26,43.88,5.47-3.16c.23-.13.25-.33,0-.45l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,239.47,340.25Zm8-4.61,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.24.13-.26.34-.05.46l5.22,3A.94.94,0,0,0,247.46,335.64Zm-16,9.22L237,341.7c.24-.13.26-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,231.49,344.86Zm31.93-18.44,5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0L257.45,323c-.23.14-.25.34-.05.46l5.23,3A.88.88,0,0,0,263.42,326.42Zm-8,4.61,5.46-3.15c.23-.14.26-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.88.88,0,0,0,255.44,331Zm16-9.22,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3A.87.87,0,0,0,271.41,321.81ZM315,257.69a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-1.39-.8a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.26.34-.05.46Zm-39.68,25.13a.94.94,0,0,0,.8,0l5.46-3.16c.23-.13.25-.33,0-.45l-5.22-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46Zm16-9.22a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34-.05.46Zm-25.72,14.84a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0L260.37,285c-.24.13-.26.34-.05.46Zm17.74-10.23a.88.88,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46Zm-33.7,19.45a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34-.05.45Zm8-4.61a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.46ZM299,266.91a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-1.39-.8a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46ZM323,253.08a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-1.39-.8a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34-.05.46Zm11,6.34a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.22-3a.88.88,0,0,0-.79,0L328.75,256c-.23.13-.25.34,0,.45Zm15.21,17.51,5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.33-.05.45l5.22,3A.87.87,0,0,0,349.14,276.93ZM307,262.3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-1.39-.8a.85.85,0,0,0-.79,0L305.64,261c-.23.13-.25.34,0,.46Zm-65.4,40a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.33,0,.45Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.59,287.72l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3A.88.88,0,0,0,300.59,287.72Zm-8-10.91L287.16,280c-.24.14-.26.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.85.85,0,0,0,292.62,276.81ZM275,287l-9.24,5.33c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l9.24-5.33c.24-.14.26-.34.05-.46l-5.22-3A.87.87,0,0,0,275,287Zm9.67-5.58-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3A.85.85,0,0,0,284.64,281.42Zm-21.43,12.37-5.46,3.15c-.24.14-.26.34-.05.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.88.88,0,0,0,263.21,293.79Zm-8,4.61-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3A.87.87,0,0,0,255.22,298.4Zm20.49,12.31,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3A.9.9,0,0,0,275.71,310.71Zm-8,4.61,5.47-3.16c.23-.13.25-.33,0-.45l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.92.92,0,0,0,267.72,315.32Zm-8,4.61,5.46-3.16c.23-.13.26-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,259.74,319.93Zm-8,4.61,5.46-3.16c.23-.13.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.46l5.22,3A.9.9,0,0,0,251.76,324.54Zm40.85-32.21,5.46-3.15c.23-.14.26-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.88.88,0,0,0,292.61,292.33Zm-8.92,13.77,12.18-7c.24-.14.26-.34.05-.46l-12.69-7.33a.85.85,0,0,0-.79,0L276.13,295c-.23.13-.25.33,0,.45l6.72,3.88c.2.12.18.33-.05.46l-5,2.91c-.23.14-.26.34-.05.46l5.23,3A.88.88,0,0,0,283.69,306.1ZM247.24,303l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34,0-.46L248,303A.85.85,0,0,0,247.24,303Zm-8,4.61-5.46,3.15c-.24.13-.26.34-.05.46l5.22,3a.94.94,0,0,0,.8,0l5.46-3.16c.23-.13.25-.33.05-.45l-5.23-3A.85.85,0,0,0,239.26,307.62Zm-44.18,49.21a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46Zm-19.69-12.34-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34,0-.46l-5.22-3A.9.9,0,0,0,175.39,344.49Zm10.13,9.24a.85.85,0,0,0,.79,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46Zm22,4.95,5.46-3.15c.24-.13.26-.34.05-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.45l5.23,3A.85.85,0,0,0,207.54,358.68Zm-8.77,4.64a.85.85,0,0,0,.79,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.33-.05.45Zm-15.39-23.44L177.91,343c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3A.88.88,0,0,0,183.38,339.88Zm39.91-23.05L217.83,320c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.23-3A.88.88,0,0,0,223.29,316.83Zm-31.93,18.44-5.46,3.15c-.24.14-.26.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3A.92.92,0,0,0,191.36,335.27Zm39.91-23-5.46,3.15c-.23.13-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.45l-5.22-3A.87.87,0,0,0,231.27,312.23Zm-16,9.21-5.46,3.16c-.24.13-.26.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,215.31,321.44Zm-8,4.61-5.47,3.16c-.23.13-.25.34,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.22-3A.88.88,0,0,0,207.33,326.05Zm-8,4.61-5.46,3.16c-.23.13-.25.33,0,.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-5.22-3A.9.9,0,0,0,199.34,330.66Zm36.45,3.09,5.46-3.15c.23-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34,0,.45l5.23,3A.85.85,0,0,0,235.79,333.75Zm74.48-67.13-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3A.88.88,0,0,0,310.27,266.62Zm-9.67,5.58-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.22-3A.9.9,0,0,0,300.6,272.2ZM318.25,262l-5.46,3.15c-.23.14-.26.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34,0-.46L319,262A.92.92,0,0,0,318.25,262Zm-44.13,41,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33,0,.45l5.23,3A.85.85,0,0,0,274.12,303ZM327,257.37a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33,0,.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46Zm-83.26,71.78,5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,243.77,329.15Zm97.9-56.53,5.46-3.15c.24-.13.26-.34.05-.46L342,266a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33-.05.45l5.23,3A.85.85,0,0,0,341.67,272.62Zm-15.45.3,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.85.85,0,0,0,326.22,272.92Zm8.27-11.24a.92.92,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.33,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46Zm1.68-1L348.86,268a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-12.7-7.32a.88.88,0,0,0-.79,0l-5.46,3.16C336,260.39,336,260.6,336.17,260.71Zm-18.44,10.22-5.46,3.15c-.23.14-.25.34,0,.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.23-3A.88.88,0,0,0,317.73,270.93Zm-60.08,34.69-5.46,3.15c-.24.14-.26.34-.05.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.88.88,0,0,0,257.65,305.62Zm75.25-28.36a.85.85,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.26.34-.05.46ZM265.63,301l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.14.26-.34,0-.46l-5.23-3A.88.88,0,0,0,265.63,301Zm-62.57,51.21a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34,0,.46Zm-9.28-9.73-5.46,3.16c-.23.13-.25.34,0,.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-5.22-3A.94.94,0,0,0,193.78,342.49Zm18.06,5.09,5.46-3.15c.24-.14.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.85.85,0,0,0,211.84,347.58Zm8-4.61,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3A.85.85,0,0,0,219.82,343Zm8-4.61,5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34-.05.45l5.22,3A.87.87,0,0,0,227.81,338.36Zm-26-.48L196.3,341c-.23.13-.25.34,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.22-3A.88.88,0,0,0,201.77,337.88Zm8-4.61-5.46,3.16c-.24.13-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,209.75,333.27Zm31.93-18.43L236.22,318c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34,0-.46l-5.23-3A.85.85,0,0,0,241.68,314.84Zm-8,4.61-5.46,3.15c-.24.13-.26.34-.05.46l5.22,3a.94.94,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3A.85.85,0,0,0,233.7,319.45Zm16-9.22-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3A.87.87,0,0,0,249.66,310.23Zm-31.93,18.43-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.23-3A.88.88,0,0,0,217.73,328.66Zm8-4.6-5.46,3.15c-.23.13-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.45l-5.22-3A.87.87,0,0,0,225.71,324.06Zm-10.19,30,5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.46l5.22,3A.88.88,0,0,0,215.52,354.08Zm-42.09-2-5.23-3a.85.85,0,0,0-.79,0L162,352.25c-.24.14-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15C173.61,352.41,173.63,352.21,173.43,352.09Zm10.4,2.61-5.22-3a.88.88,0,0,0-.79,0l-8.41,4.85c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l8.41-4.85C184,355,184,354.82,183.83,354.7Zm-18.2-8.57-5.23-3a.88.88,0,0,0-.79,0L152.89,347c-.23.13-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l6.72-3.88C165.81,346.45,165.83,346.25,165.63,346.13Zm5.15-3a.9.9,0,0,0,.8,0L177,340c.23-.13.25-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46ZM193.4,357.8l-5.22-3a.87.87,0,0,0-.8,0l-10.5,6.06c-.23.14-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l10.5-6.06C193.59,358.12,193.61,357.92,193.4,357.8Zm3.68,6.49-5.22-3a.88.88,0,0,0-.79,0l-6.73,3.88c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l6.73-3.88C197.27,364.61,197.29,364.41,197.08,364.29Zm33.06-55.4a.92.92,0,0,0,.79,0l5.46-3.16c.24-.13.26-.33.05-.45l-5.22-3a.87.87,0,0,0-.8,0L225,305.41c-.23.13-.25.34-.05.46Zm-16,9.21a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34,0-.46l-5.22-3a.88.88,0,0,0-.79,0L209,314.63c-.23.13-.25.34,0,.46Zm-35.4,20.44a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.33,0-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.26.34-.05.46Zm43.39-25.05a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0L217,310c-.24.13-.26.34,0,.46Zm-16,9.22a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.22-3a.9.9,0,0,0-.8,0L201,319.24c-.23.13-.25.34,0,.46ZM201,364.61a.88.88,0,0,0-.79,0l-8.4,4.85c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l8.4-4.85c.24-.14.26-.34,0-.46Zm-6.27-35.28a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46Zm-8,4.61a.92.92,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46ZM348.9,279.22a.92.92,0,0,0-.79,0L334.66,287c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l13.44-7.76c.23-.13.26-.34.05-.46Zm-17.64,10.19a.9.9,0,0,0-.8,0L325,292.59c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46ZM223.51,349.47l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0L217.54,346c-.24.13-.26.34,0,.46l5.22,3A.9.9,0,0,0,223.51,349.47Zm91.78-50.84a.85.85,0,0,0-.79,0L309,301.81c-.23.14-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46Zm41.6-24a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46ZM370.1,273l-12.7-7.32a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34,0,.45l12.69,7.33a.87.87,0,0,0,.8,0l5.46-3.15C370.28,273.35,370.3,273.14,370.1,273Zm-84.64,42.83a.9.9,0,0,0-.8,0l-6.72,3.88c-.23.14-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l6.73-3.88c.23-.13.25-.34,0-.46Zm20.17-11.64a.87.87,0,0,0-.8,0l-8.4,4.85c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l8.41-4.85c.23-.14.25-.34,0-.46ZM267,326.53a.88.88,0,0,0-.79,0l-45,26c-.23.14-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l45-26c.23-.13.25-.34.05-.46Zm-47.48,27.41a.85.85,0,0,0-.79,0L212,357.85c-.24.13-.26.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l6.72-3.89c.23-.13.25-.33.05-.45Zm56.72-32.75a.85.85,0,0,0-.79,0l-6.72,3.88c-.23.13-.26.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l6.72-3.88c.24-.14.26-.34.05-.46Zm-66,38.09a.9.9,0,0,0-.8,0l-6.72,3.88c-.23.14-.25.34,0,.46l5.22,3a.85.85,0,0,0,.79,0l6.73-3.88c.23-.13.25-.34,0-.46Zm84.45-48.76a.88.88,0,0,0-.79,0l-6.72,3.89c-.24.13-.26.33-.05.45l5.22,3a.87.87,0,0,0,.8,0l6.72-3.88c.23-.13.25-.34.05-.46ZM323.27,294a.85.85,0,0,0-.79,0L317,297.2c-.23.14-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46Zm17.88-12.48,5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3A.85.85,0,0,0,341.15,281.54Zm-32.57,1.57L314,280c.23-.14.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46l5.22,3A.87.87,0,0,0,308.58,283.11Zm-21.21,29.48,16-9.21c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-16,9.22c-.23.13-.25.33,0,.45l5.23,3A.85.85,0,0,0,287.37,312.59Zm45-26.41a.85.85,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46Zm-6.67-4.34,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3A.87.87,0,0,0,325.71,281.84ZM279.39,317.2l5.46-3.15c.23-.14.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.85.85,0,0,0,279.39,317.2Zm35.34-20.83a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46Zm-75.26,43.88,5.47-3.16c.23-.13.25-.33,0-.45l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,239.47,340.25Zm8-4.61,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.24.13-.26.34-.05.46l5.22,3A.94.94,0,0,0,247.46,335.64Zm-16,9.22L237,341.7c.24-.13.26-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,231.49,344.86Zm31.93-18.44,5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0L257.45,323c-.23.14-.25.34-.05.46l5.23,3A.88.88,0,0,0,263.42,326.42Zm-8,4.61,5.46-3.15c.23-.14.26-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.88.88,0,0,0,255.44,331Zm16-9.22,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3A.87.87,0,0,0,271.41,321.81ZM315,257.69a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-1.39-.8a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.26.34-.05.46Zm-39.68,25.13a.94.94,0,0,0,.8,0l5.46-3.16c.23-.13.25-.33,0-.45l-5.22-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46Zm16-9.22a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34.05-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34-.05.46Zm-25.72,14.84a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0L260.37,285c-.24.13-.26.34-.05.46Zm17.74-10.23a.88.88,0,0,0,.79,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46Zm-33.7,19.45a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34-.05.45Zm8-4.61a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.46ZM299,266.91a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-1.39-.8a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46ZM323,253.08a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-1.39-.8a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34-.05.46Zm11,6.34a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.22-3a.88.88,0,0,0-.79,0L328.75,256c-.23.13-.25.34,0,.45Zm15.21,17.51,5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.33-.05.45l5.22,3A.87.87,0,0,0,349.14,276.93ZM307,262.3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-1.39-.8a.85.85,0,0,0-.79,0L305.64,261c-.23.13-.25.34,0,.46Zm-65.4,40a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.33,0,.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.22 343.44 266.34 344.09 296.09 361.26 348.99 330.72 350.09 330.09 319.22 312.27 265.22 343.44",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.34 344.09 296.09 361.26 348.99 330.72 319.22 313.54 266.34 344.09",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.34 344.09 296.09 361.26 348.99 330.72 319.22 313.54 266.34 344.09",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,337.88a7.53,7.53,0,0,0,1.5.64,7,7,0,0,1-1.5-.63,3.46,3.46,0,0,1-.47-.31A4.66,4.66,0,0,0,112.68,337.88Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.26,338.34a.29.29,0,0,1,.08-.07l-.06.06Z",
    style: {
      fill: "#54BDC1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.38,109.47l-3.2-1.86L132.89,201.89V298a2.41,2.41,0,0,0,1,2.21h0l3.2,1.86h0a2.37,2.37,0,0,0,2.41-.24L296,211.52a7.57,7.57,0,0,0,3.41-5.92Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.09,299.88c0,2.18,1.52,3.06,3.41,2L296,211.52a7.57,7.57,0,0,0,3.41-5.92V109.47L136.09,203.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59,110.84V205.6a6.77,6.77,0,0,1-3,5.23L139.11,301.17a2.31,2.31,0,0,1-1.13.36c-1,0-1.11-1.15-1.11-1.65V204.2l161.72-93.36m.79-1.37L136.09,203.75v96.13c0,1.55.77,2.44,1.89,2.44a3.08,3.08,0,0,0,1.52-.47L296,211.52a7.57,7.57,0,0,0,3.41-5.92V109.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.09 203.75 136.09 218.53 299.38 124.25 299.38 109.47 136.09 203.75",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.55,150.39v3.18c0,.65.46.92,1,.59l50.2-29v-5.55l-50.2,29A2.26,2.26,0,0,0,238.55,150.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.16,116.52c.56-.32,1-.06,1,.6v3.18a2.28,2.28,0,0,1-1,1.77l-5.39,3.11v-5.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.76,120.89l-.6-.19a3.44,3.44,0,0,0,.09-.77,1.45,1.45,0,0,0-.54-1.29.87.87,0,0,0-.88,0,3.07,3.07,0,0,0-1.2,2.49,1.4,1.4,0,0,0,.55,1.28.76.76,0,0,0,.38.11.93.93,0,0,0,.49-.15,2.43,2.43,0,0,0,1-1.3l.6.19h.07a.22.22,0,0,0,.21-.15A.22.22,0,0,0,294.76,120.89ZM292.83,122a.43.43,0,0,1-.43,0,1.05,1.05,0,0,1-.32-.9,2.67,2.67,0,0,1,1-2.11.63.63,0,0,1,.27-.08.29.29,0,0,1,.16,0,1.05,1.05,0,0,1,.33.9A2.69,2.69,0,0,1,292.83,122Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.21,98.27a2.37,2.37,0,0,0-2.44.22L136.3,188.83a7.51,7.51,0,0,0-3.41,5.91v7.15l3.2,1.86,163.29-94.28v-7.15a2.41,2.41,0,0,0-1-2.2C297.82,99.79,295.77,98.61,295.21,98.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.09,196.6a7.52,7.52,0,0,1,3.41-5.91L296,100.35c1.88-1.09,3.41-.2,3.41,2v7.15L136.09,203.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.43,100.14a2.38,2.38,0,0,0-2.46.21L139.5,190.69a7,7,0,0,0-2.41,2.54l-3.21-1.85a7,7,0,0,1,2.42-2.55L292.77,98.49a2.37,2.37,0,0,1,2.44-.22c.56.34,2.61,1.52,3.18,1.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.17,113.16a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.44,1.6.93a3.55,3.55,0,0,0,1.6-2.78C281.77,113.06,281.05,112.65,280.17,113.16Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,109.93a3.56,3.56,0,0,0-1.6,2.78c0,1,.72,1.43,1.6.92a3.52,3.52,0,0,0,1.6-2.77C287.37,109.84,286.66,109.42,285.77,109.93Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.38,106.71a3.53,3.53,0,0,0-1.61,2.77c0,1,.72,1.43,1.61.92a3.54,3.54,0,0,0,1.6-2.77C293,106.61,292.26,106.2,291.38,106.71Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,301.85l28.61-16.51V200l-32,18.49v81.35C136.09,302.06,137.61,302.94,139.5,301.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32,201.41v83.47l-28.21,16.29a2.31,2.31,0,0,1-1.13.36c-1,0-1.11-1.15-1.11-1.65V219l30.45-17.57m.79-1.37-32,18.49v81.35c0,1.55.77,2.44,1.89,2.44a3.08,3.08,0,0,0,1.52-.47l28.61-16.51V200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,219.79,162,210.93c.56-.32,1-.06,1,.59v1.34a2.26,2.26,0,0,1-1,1.77l-15.31,8.85c-.57.33-1,.07-1-.59v-1.33A2.25,2.25,0,0,1,146.72,219.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,223.41v1.33a2.26,2.26,0,0,1-1,1.77l-1.16.67c-.56.33-1,.06-1-.59v-1.33a2.28,2.28,0,0,1,1-1.78l1.16-.66C142,222.49,142.49,222.76,142.49,223.41Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,227.15,162,218.3c.56-.33,1-.06,1,.59v1.33a2.26,2.26,0,0,1-1,1.78l-15.31,8.85c-.57.33-1,.06-1-.59v-1.33A2.26,2.26,0,0,1,146.72,227.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,230.78v1.33a2.26,2.26,0,0,1-1,1.77l-1.16.67c-.56.32-1,.06-1-.59v-1.34a2.28,2.28,0,0,1,1-1.77l1.16-.67C142,229.86,142.49,230.12,142.49,230.78Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,234.52,162,225.67c.56-.33,1-.07,1,.59v1.33a2.25,2.25,0,0,1-1,1.77l-15.31,8.86c-.57.32-1,.06-1-.59v-1.34A2.26,2.26,0,0,1,146.72,234.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,238.14v1.34a2.28,2.28,0,0,1-1,1.77l-1.16.66c-.56.33-1,.07-1-.59V240a2.26,2.26,0,0,1,1-1.77l1.16-.67C142,237.22,142.49,237.49,142.49,238.14Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,259,162,250.09c.56-.32,1-.06,1,.6V252a2.25,2.25,0,0,1-1,1.77l-15.31,8.86c-.57.32-1,.06-1-.59v-1.34A2.26,2.26,0,0,1,146.72,259Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,262.57v1.33a2.28,2.28,0,0,1-1,1.78l-1.16.66c-.56.33-1,.07-1-.59v-1.33a2.26,2.26,0,0,1,1-1.77l1.16-.67C142,261.65,142.49,261.92,142.49,262.57Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,265.47,162,256.62c.56-.33,1-.06,1,.59v1.33a2.26,2.26,0,0,1-1,1.78l-15.31,8.85c-.57.33-1,.06-1-.59v-1.33A2.26,2.26,0,0,1,146.72,265.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,269.1v1.33a2.26,2.26,0,0,1-1,1.77l-1.16.67c-.56.32-1,.06-1-.59v-1.34a2.28,2.28,0,0,1,1-1.77l1.16-.66C142,268.18,142.49,268.44,142.49,269.1Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,272,162,263.14c.56-.32,1-.06,1,.6v1.33a2.26,2.26,0,0,1-1,1.77l-15.31,8.86c-.57.32-1,.06-1-.6v-1.33A2.26,2.26,0,0,1,146.72,272Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,275.62V277a2.28,2.28,0,0,1-1,1.78l-1.16.66c-.56.33-1,.06-1-.59v-1.33a2.26,2.26,0,0,1,1-1.77l1.16-.67C142,274.7,142.49,275,142.49,275.62Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.69 242.56 145.69 244.86 147.68 242.56 145.69 242.56",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,242.09c0,.42.3.59.68.38l12.8-7.37a1.53,1.53,0,0,0,.68-1.18c0-.43-.31-.61-.68-.39l-12.8,7.39A1.49,1.49,0,0,0,148.9,242.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.69 246.26 145.69 248.56 147.68 246.26 145.69 246.26",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,245.78c0,.43.3.6.68.38l12.8-7.37a1.5,1.5,0,0,0,.68-1.17c0-.44-.31-.61-.68-.39l-12.8,7.39A1.47,1.47,0,0,0,148.9,245.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.69 249.95 145.69 252.25 147.68 249.95 145.69 249.95",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,249.48c0,.43.3.6.68.38l12.8-7.37a1.52,1.52,0,0,0,.68-1.18c0-.43-.31-.6-.68-.39l-12.8,7.39A1.49,1.49,0,0,0,148.9,249.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.69 253.65 145.69 255.95 147.68 253.65 145.69 253.65",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,253.18c0,.42.3.59.68.37l12.8-7.36a1.53,1.53,0,0,0,.68-1.18c0-.43-.31-.61-.68-.39L149.58,252A1.49,1.49,0,0,0,148.9,253.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71,204.45v19.26c0,.81.57,1.13,1.27.73l21.18-12.23a2.78,2.78,0,0,0,1.26-2.19V194.18c0-.81-.56-1.13-1.26-.73l-12.29,7.1c-.7.4-1.27.07-1.27-.73v-.51c0-.8-.56-1.13-1.26-.73L179,202.26A2.79,2.79,0,0,0,177.71,204.45Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.88,227.35v1.23c0,.6.42.85.94.55L198.71,220a2.07,2.07,0,0,0,.95-1.64v-1.23c0-.61-.42-.85-.95-.55l-15.89,9.17A2.11,2.11,0,0,0,181.88,227.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.16,187.54V206.8c0,.81.57,1.13,1.27.73l21.18-12.23a2.78,2.78,0,0,0,1.26-2.19V177.27c0-.81-.56-1.13-1.26-.73l-12.29,7.09c-.7.41-1.27.08-1.27-.72v-.51c0-.8-.56-1.13-1.26-.73l-6.36,3.68A2.79,2.79,0,0,0,207.16,187.54Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,210.43v1.24c0,.6.42.85.94.54L228.16,203a2.08,2.08,0,0,0,1-1.64v-1.23c0-.61-.42-.85-1-.55l-15.89,9.17A2.1,2.1,0,0,0,211.33,210.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71,243.15v19.26c0,.81.57,1.13,1.27.73l21.18-12.23a2.78,2.78,0,0,0,1.26-2.19V232.88c0-.81-.56-1.13-1.26-.73l-12.29,7.1c-.7.4-1.27.07-1.27-.73V238c0-.8-.56-1.13-1.26-.73L179,241A2.79,2.79,0,0,0,177.71,243.15Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.88,266.05v1.23c0,.6.42.85.94.55l15.89-9.18a2.07,2.07,0,0,0,.95-1.64v-1.23c0-.61-.42-.85-.95-.55l-15.89,9.17A2.11,2.11,0,0,0,181.88,266.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.16,226.24V245.5c0,.81.57,1.13,1.27.73L229.61,234a2.78,2.78,0,0,0,1.26-2.19V216c0-.81-.56-1.13-1.26-.73l-12.29,7.1c-.7.4-1.27.07-1.27-.73v-.51c0-.8-.56-1.13-1.26-.73l-6.36,3.68A2.79,2.79,0,0,0,207.16,226.24Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,249.13v1.24c0,.6.42.85.94.55l15.89-9.18a2.08,2.08,0,0,0,1-1.64v-1.23c0-.61-.42-.85-1-.55l-15.89,9.17A2.11,2.11,0,0,0,211.33,249.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,169.69V189c0,.8.56,1.13,1.26.73l21.18-12.23a2.79,2.79,0,0,0,1.27-2.19V159.43c0-.81-.57-1.14-1.27-.73l-12.29,7.09c-.7.41-1.26.08-1.26-.73v-.5c0-.81-.57-1.13-1.26-.73l-6.37,3.68A2.77,2.77,0,0,0,237,169.69Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78,193.52v1.24c0,.6.42.85.94.54l15.89-9.17a2.08,2.08,0,0,0,.95-1.64v-1.24c0-.6-.42-.85-.95-.54l-15.89,9.17A2.1,2.1,0,0,0,240.78,193.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.06,153.71V173c0,.8.57,1.13,1.27.73l21.18-12.23a2.81,2.81,0,0,0,1.26-2.19V143.44c0-.8-.56-1.13-1.26-.72l-12.29,7.09c-.7.41-1.27.08-1.27-.73v-.5c0-.81-.56-1.13-1.26-.73l-6.36,3.67A2.82,2.82,0,0,0,266.06,153.71Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23,176.61v1.23c0,.61.42.85.94.55l15.89-9.17a2.08,2.08,0,0,0,.95-1.64v-1.24c0-.6-.42-.85-.95-.54L271.17,175A2.1,2.1,0,0,0,270.23,176.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78,232.21v1.23c0,.61.42.85.94.55l15.89-9.17a2.1,2.1,0,0,0,.95-1.65v-1.23c0-.6-.42-.85-.95-.55l-15.89,9.18A2.08,2.08,0,0,0,240.78,232.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.17,205.13l16.49-9.51c.75-.44,1.36-.08,1.36.79v19a3,3,0,0,1-1.36,2.37l-16.49,9.51c-.75.44-1.36.09-1.36-.78v-19A3,3,0,0,1,241.17,205.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,227.89a1,1,0,0,1-.55-.14,1.33,1.33,0,0,1-.59-1.22v-19a3.41,3.41,0,0,1,1.56-2.71l16.48-9.51a1.22,1.22,0,0,1,2,1.13v19a3.41,3.41,0,0,1-1.57,2.71l-16.48,9.52A1.69,1.69,0,0,1,240.56,227.89Zm.81-22.41a2.62,2.62,0,0,0-1.17,2v19a.46.46,0,0,0,.78.44l16.48-9.51a2.64,2.64,0,0,0,1.17-2v-19a.6.6,0,0,0-.21-.54c-.13-.08-.33,0-.57.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.59,198.19l-3.67,2.12a3,3,0,0,0-1.36,2.36v4.25c0,.87.61,1.22,1.36.78l3.67-2.12a3,3,0,0,0,1.37-2.36V199C261,198.11,260.35,197.75,259.59,198.19Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,207.19l8.26-4.75c.37-.22.68,0,.68.39v.27a1.53,1.53,0,0,1-.68,1.18L242.43,209c-.38.21-.68,0-.68-.4v-.27A1.51,1.51,0,0,1,242.43,207.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,210.88l8.26-4.75c.37-.22.68,0,.68.4v.26a1.53,1.53,0,0,1-.68,1.18l-8.26,4.76c-.38.22-.68,0-.68-.39v-.28A1.51,1.51,0,0,1,242.43,210.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,214.57l8.26-4.75c.37-.21.68,0,.68.4v.26a1.5,1.5,0,0,1-.68,1.18l-8.26,4.76c-.38.22-.68,0-.68-.39v-.27A1.51,1.51,0,0,1,242.43,214.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,218.27l13.72-7.91c.37-.22.68,0,.68.39V211a1.53,1.53,0,0,1-.68,1.18l-13.72,7.91c-.38.22-.68,0-.68-.39v-.27A1.48,1.48,0,0,1,242.43,218.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,222l13.72-7.91c.37-.22.68,0,.68.4v.26a1.52,1.52,0,0,1-.68,1.18l-13.72,7.92c-.38.21-.68,0-.68-.4v-.27A1.49,1.49,0,0,1,242.43,222Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,215.57v1.24c0,.6.43.85,1,.54l15.89-9.17a2.11,2.11,0,0,0,.95-1.64V205.3c0-.6-.43-.85-.95-.54l-15.89,9.17A2.11,2.11,0,0,0,269.59,215.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,188.5,286.47,179c.76-.43,1.37-.08,1.37.79v19a3,3,0,0,1-1.37,2.36L270,210.68c-.75.43-1.36.08-1.36-.79v-19A3,3,0,0,1,270,188.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.38,211.26a1.12,1.12,0,0,1-.55-.14,1.36,1.36,0,0,1-.6-1.23v-19a3.4,3.4,0,0,1,1.56-2.7l16.48-9.52a1.22,1.22,0,0,1,2,1.13v19a3.4,3.4,0,0,1-1.56,2.7L270.19,211A1.63,1.63,0,0,1,269.38,211.26Zm.81-22.42a2.6,2.6,0,0,0-1.17,2v19c0,.27.07.47.2.54a.6.6,0,0,0,.57-.09l16.48-9.52a2.6,2.6,0,0,0,1.17-2v-19c0-.27-.07-.47-.2-.54a.6.6,0,0,0-.57.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.41,181.55l-3.67,2.12a3,3,0,0,0-1.37,2.37v4.24c0,.87.61,1.22,1.37.79l3.67-2.12a3.05,3.05,0,0,0,1.37-2.37v-4.24C289.78,181.47,289.16,181.12,288.41,181.55Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,190.55l8.25-4.75c.38-.21.69,0,.69.4v.26a1.49,1.49,0,0,1-.69,1.18l-8.25,4.76c-.38.22-.69,0-.69-.39v-.28A1.52,1.52,0,0,1,271.25,190.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,194.25l8.25-4.75c.38-.22.69-.05.69.39v.26a1.52,1.52,0,0,1-.69,1.19l-8.25,4.75c-.38.22-.69,0-.69-.39v-.27A1.49,1.49,0,0,1,271.25,194.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,197.94l8.25-4.75c.38-.22.69,0,.69.39v.27a1.52,1.52,0,0,1-.69,1.18l-8.25,4.76c-.38.21-.69,0-.69-.4v-.27A1.49,1.49,0,0,1,271.25,197.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,201.63,285,193.72c.38-.21.69,0,.69.4v.26a1.49,1.49,0,0,1-.69,1.18l-13.71,7.92c-.38.22-.69,0-.69-.4v-.27A1.52,1.52,0,0,1,271.25,201.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,205.32l13.71-7.9c.38-.22.69,0,.69.39v.26a1.52,1.52,0,0,1-.69,1.19l-13.71,7.91c-.38.22-.69,0-.69-.39v-.28A1.52,1.52,0,0,1,271.25,205.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.09 203.75 132.89 201.89 132.89 216.68 136.09 218.53 136.09 203.75",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.09 203.75 132.89 201.89 132.89 216.68 136.09 218.53 136.09 203.75",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letter--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.83,271.28a2.68,2.68,0,0,1,1.2-2.09l61.63-35.58a2.69,2.69,0,0,1,2.41,0l1.36.79a2.67,2.67,0,0,1,1.2,2.08v47.24a2.67,2.67,0,0,1-1.2,2.09L92.8,321.39a2.69,2.69,0,0,1-2.41,0L89,320.61a2.7,2.7,0,0,1-1.2-2.09Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,270.09l3.42,2,63.68-36.77a2.46,2.46,0,0,0-.85-.9l-1.36-.78a2.63,2.63,0,0,0-2.41,0L89,269.19A2.63,2.63,0,0,0,88.18,270.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.83,271.28v47.24A2.65,2.65,0,0,0,89,320.6l1.36.79a1.66,1.66,0,0,0,.33.15,2.45,2.45,0,0,0,.5.11,3,3,0,0,0,1,0l.23-.06.14-.06a.7.7,0,0,1-.57,0,.84.84,0,0,1-.37-.8V273.46a1.05,1.05,0,0,1,.63-1l-.63-.36-3.42-2A2.47,2.47,0,0,0,87.83,271.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,272.07l28.54,10.66a4.64,4.64,0,0,0,5.5-1.81l4.59-7,25.28-38.72-24.37,39,24.49,9.58a2.48,2.48,0,0,1-.38,1.21l-24.18-10.68-5.32,8.52a4.63,4.63,0,0,1-5.81,1.78l-3.79-1.67L92,321.49a.84.84,0,0,1-.37-.8v-.78L116,282.85Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chat--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chat--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.25,134.29,416.5,131a.55.55,0,0,1-.27-.23l-1.06-1.85,3.42-2-.11.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.07,127.19l4,6.89a.59.59,0,0,0,1.07-.1l4.21-12.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.84,90.4a6.12,6.12,0,0,0-2.78-4.81l-2.26-1.31a6.14,6.14,0,0,0-5.57,0l-45,26a6.15,6.15,0,0,0-2.78,4.82v22.81a6.14,6.14,0,0,0,2.78,4.82l2.26,1.31a6.21,6.21,0,0,0,5.57,0l45.3-26.17c2.5-1.43,2.52-2.86,2.52-4.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.41,137.89a6.14,6.14,0,0,0,2.78,4.82l2.26,1.31a6.22,6.22,0,0,0,5.09.23c-1.31.5-2.3-.25-2.3-1.84V119.6a5.69,5.69,0,0,1,.81-2.74l-7.83-4.52a5.69,5.69,0,0,0-.81,2.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.75,89.61c-.32-1.18-1.4-1.55-2.68-.81l-45.05,26a5.47,5.47,0,0,0-2,2.08l-7.83-4.52a5.6,5.6,0,0,1,2-2.07l45-26a6.21,6.21,0,0,1,5.57,0l2.27,1.31A6.12,6.12,0,0,1,436.75,89.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.71,121.25l32.18-18.67c.93-.53,1.68-.29,1.68.55a3.38,3.38,0,0,1-1.68,2.5l-32.18,18.66c-.93.54-1.68.3-1.68-.54A3.38,3.38,0,0,1,393.71,121.25Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.71,128.89l32.18-18.66c.93-.54,1.68-.29,1.68.55a3.35,3.35,0,0,1-1.68,2.49l-32.18,18.66c-.93.54-1.68.3-1.68-.54A3.38,3.38,0,0,1,393.71,128.89Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.62,142.71l-5.76-3.33a.6.6,0,0,1-.27-.23l-1.06-1.85,3.42-2-.1.3Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.62,142.71l-5.76-3.33a.6.6,0,0,1-.27-.23l-1.06-1.85,3.42-2-.1.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,135.61l4,6.89a.6.6,0,0,0,1.08-.1l4.2-12.15Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,78.89a6.18,6.18,0,0,0-2.78-4.82l-2.27-1.31a6.18,6.18,0,0,0-5.56,0l-53.48,30.89a6.15,6.15,0,0,0-2.78,4.82v26.25a6.15,6.15,0,0,0,2.78,4.82l2.26,1.3a6.14,6.14,0,0,0,5.57,0l53.74-31.07c2.49-1.43,2.52-2.86,2.52-4.63Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,134.72a6.15,6.15,0,0,0,2.78,4.82l2.26,1.3a6.22,6.22,0,0,0,5.09.24c-1.31.49-2.3-.26-2.3-1.84V113a5.69,5.69,0,0,1,.81-2.74l-7.83-4.52a5.69,5.69,0,0,0-.81,2.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.56,78.1c-.33-1.18-1.41-1.56-2.69-.82l-53.48,30.89a5.55,5.55,0,0,0-2,2.08l-7.83-4.52a5.68,5.68,0,0,1,2-2.07L381,72.76a6.21,6.21,0,0,1,5.57,0l2.27,1.32A6.16,6.16,0,0,1,391.56,78.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.08,120.36,369,103.61c.93-.54,1.68-.29,1.68.55a3.35,3.35,0,0,1-1.68,2.49L340.08,123.4c-.93.54-1.68.29-1.68-.55A3.37,3.37,0,0,1,340.08,120.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.08,128l40.61-23.57c.93-.53,1.69-.29,1.69.55a3.4,3.4,0,0,1-1.69,2.5L340.08,131c-.93.54-1.68.29-1.68-.55A3.37,3.37,0,0,1,340.08,128Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.08,112.34l40.61-23.57c.93-.54,1.69-.29,1.69.55a3.4,3.4,0,0,1-1.69,2.5l-40.61,23.56c-.93.54-1.68.29-1.68-.55A3.37,3.37,0,0,1,340.08,112.34Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16--inject-92",
    d: "M84.27,358.44l132.6,76.33c1.31.75,1.47,2.66,1,4.1a11.83,11.83,0,0,1-7.51,7.81c-2.61,1-5.6.33-8-1.08L68.62,367.47l-17.11-20.6a.84.84,0,0,1,1-1.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.81,362.35,54.36,342.82a.78.78,0,0,1,.76-1.26l25.08,5.52Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,341.56h.13l25.08,5.52-5,8.08-2.7-1.63L55,342.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.12,341.56a.78.78,0,0,0-.76,1.26l3.21,3.81h0a4.28,4.28,0,0,1,2.52-3.7l.4-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.65,415.56l-2-1.22-2.44-1.48-109-65.78a11.37,11.37,0,0,0-6.92,4.65c-2.62,3.48-3.69,8-2.46,10.61l108.93,65.74,4.67,2.81C181.5,428.9,190.69,413.6,193.65,415.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.65,415.56l-2-1.22-2.43-1.48-109-65.77a12.1,12.1,0,0,0-8,6.24l113.7,69.37c-.16.29-.11.43.12.43C188.39,418.78,192,414.46,193.65,415.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,410.88l-4.52-2.72c-1.28-.83-3.81,1.46-6,4.5-3,4-4.84,9.78-3.14,10.89l3.33,2,1.2.7c-1.7-1.11.16-6.85,3.14-10.89,2.14-2.92,4.57-5.14,5.89-4.56h0A.31.31,0,0,1,186,410.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.83,410.22c-3-1.94-12.16,13.43-9.18,15.37l4.52,2.74c-3-1.94,6.2-17.31,9.18-15.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.65,415.56l-4.46-2.7c-2.91-1.93-11.89,12.83-9.44,15.22l.16.13,4.51,2.68C181.5,428.9,190.69,413.6,193.65,415.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,341.87a.74.74,0,0,1,.64-.32A.72.72,0,0,0,54.33,341.87Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,427l-18.93-11.46c-1.26-.84-3.78,1.41-6,4.42-3,4-4.89,9.78-3.22,10.91l0,0,19,11.49c3.79,2.28,9.35-4.83,10.52-10.37C214.41,430,214.09,428.11,212.58,427Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,428.91c-3.25,3.06-5.26,8.19-4.49,11.45a3.13,3.13,0,0,0,1.74,2.32c3.75,1.23,8.78-5.41,9.89-10.65.45-2,.14-3.84-1.29-4.94C211.22,426.24,209,426.83,206.81,428.91Z",
    style: {
      opacity: 0.1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.66,385.19s1.57,10.71,4.7,14.69c2.82,3.58,4.85,8.16,8.2,11.89.73.82,2.39,2.33,3,3a1.29,1.29,0,0,1-.1,2c-1.43,1.42-7.62,1.86-11.13-.68s-7-7.42-9.12-9.48l-2.77-2.74a2.81,2.81,0,0,1-.74-2.66c.07-.27.14-.59.22-1,.44-2-2.34-10.16-2.34-10.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,406a5.52,5.52,0,0,0,.34,1.93c.35.76,2.14,1.9,3.27,2.44a7.27,7.27,0,0,1,3.6,3.72,12.9,12.9,0,0,0,6.1,5.88,18.53,18.53,0,0,0,11,.92c4.57-.91,4.88-3.62,4.88-3.62s.2-2.55-.95-2.92S334.2,406,334.2,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,394.82a24.27,24.27,0,0,1,.31,6.59c-.1,1.33-.12,3.42.88,4.59,1.38,1.85,4.29,2.4,6.18,4.92s4.69,7.08,10.71,8.15,10.54-.92,11.62-2.65,0-3.32-3.86-5.32c-4.12-2.12-9.62-8.58-9.62-8.58a23.3,23.3,0,0,1-3.88-6.45l-1.46-4.66c-.32-.91-6.8,1-7.48,2.34l.78,4.13-1.67-3.9A4.22,4.22,0,0,0,333,394.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.18,417.72a7.63,7.63,0,0,1,4.32-6.6c4.47-2.4,7.25-1,8.65,0,1.68,1.16,4.08,3.59,2.68,5.41-1.5,2-4,3-8.57,3.09A11,11,0,0,1,347.18,417.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,403.82a.53.53,0,0,0,.41-.23c.5-.72,3.74-3.46,6.93-2.64.16-.37-.12-.74-.78-1.12-3.34-.24-6.42,2.34-7,3.22a.47.47,0,0,0,.15.68A.53.53,0,0,0,340.71,403.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.92,403.31a1.56,1.56,0,0,0-.92-1.09,9.48,9.48,0,0,0-6.61,3.24.47.47,0,0,0,.15.68.51.51,0,0,0,.72-.14C343.75,405.3,346.82,402.7,349.92,403.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.62,398.78a.92.92,0,0,0-.65-1.24c-3.66-.8-7.21,2.15-7.86,3.1a.47.47,0,0,0,.15.68.49.49,0,0,0,.31.09.54.54,0,0,0,.41-.23C339.51,400.4,343.21,397.3,346.62,398.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,408.36a2.84,2.84,0,0,0-1.45-1.31,9.37,9.37,0,0,0-6.88,3.23.48.48,0,0,0,.15.69.55.55,0,0,0,.31.08.54.54,0,0,0,.41-.23C348.07,410.06,351.65,407.05,355,408.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,408.64a.51.51,0,0,0,.4-.23c.5-.71,3.67-3.39,6.83-2.66a1.76,1.76,0,0,0-1.09-1.12,9.43,9.43,0,0,0-6.6,3.24.48.48,0,0,0,.14.69A.61.61,0,0,0,345,408.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,309.41c-.74,6.7-2.28,10.79.4,16.67,2.75,6,10.38,10.43,18.85,15.83,7.86,5,15.5,10.69,17.45,12,2.1,1.41,3.19,2.22,3.63,5.7.51,4.08,2.44,10.62,6.75,19.14,4.91,9.73,6.82,14.59,6.82,14.59s6.31-2.07,11.12-4.08c0,0-8.56-39.53-10.47-44.85s-22.37-22.29-22.37-22.29,2-8.52,3.49-14.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.52,375.84s2.84,8.77,5.11,12.88a63.27,63.27,0,0,0,8.06,11.68c.71.8,2.34,2.28,2.93,2.93a1.28,1.28,0,0,1-.1,2c-1.41,1.39-7.48,1.83-10.94-.67s-6.88-7.29-8.95-9.31l-2.72-2.69a2.76,2.76,0,0,1-.73-2.61c.07-.26.14-.58.22-.94.43-2-2.3-10-2.3-10Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.46,297.59c-1.11,6.21-1.45,9.73.73,16s7.28,16.24,16.05,21.15C329.5,338.8,338.93,343.8,341,345c1.81,1.07,3.23,2.48,3.94,7,.64,4.06,2.76,8.69,7.46,17a122.48,122.48,0,0,1,6.86,13.57,64.43,64.43,0,0,1,10.83-4s-10.42-38.86-12.33-44.18S341.92,321.25,336,317.82s-9.28-5.57-16.07-10.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.6,394.69a5.54,5.54,0,0,0,.34,1.89c.34.75,2.1,1.87,3.21,2.4a7.12,7.12,0,0,1,3.53,3.65,12.75,12.75,0,0,0,6,5.78,18.21,18.21,0,0,0,10.77.9c4.48-.9,4.8-3.56,4.8-3.56s.18-2.49-.94-2.87S361.6,394.69,361.6,394.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.44,383.71a24.23,24.23,0,0,1,.31,6.47c-.1,1.3-.13,3.36.85,4.51,1.36,1.81,4.22,2.35,6.08,4.83s4.6,7,10.52,8,10.34-.9,11.4-2.6,0-3.26-3.78-5.22c-4.05-2.09-9.46-8.43-9.46-8.43a22.72,22.72,0,0,1-3.8-6.34l-1.2-4.31c-.32-.89-6.78.77-7.46,2l.8,3.94-1.77-3.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35,406.19a7.49,7.49,0,0,1,4.24-6.48c4.4-2.35,7.13-.94,8.5,0,1.64,1.13,4,3.52,2.64,5.31-1.49,1.94-3.9,2.89-8.43,3A10.81,10.81,0,0,1,374.35,406.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,392.54a.5.5,0,0,0,.4-.22c.49-.71,3.67-3.4,6.81-2.59.15-.36-.12-.73-.76-1.1a9.15,9.15,0,0,0-6.9,3.16.47.47,0,0,0,.14.67A.52.52,0,0,0,368,392.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.05,392a1.56,1.56,0,0,0-.91-1.07,9.37,9.37,0,0,0-6.49,3.18.48.48,0,0,0,.15.68.55.55,0,0,0,.31.08.49.49,0,0,0,.39-.22C371,394,374,391.45,377.05,392Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.8,387.6a.9.9,0,0,0-.64-1.22c-3.59-.78-7.07,2.11-7.72,3a.49.49,0,0,0,.15.68.58.58,0,0,0,.31.08.54.54,0,0,0,.4-.22C366.83,389.19,370.46,386.14,373.8,387.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,397a2.85,2.85,0,0,0-1.42-1.28,9.2,9.2,0,0,0-6.76,3.17.47.47,0,0,0,.14.67.52.52,0,0,0,.31.08.49.49,0,0,0,.4-.21C375.23,398.67,378.74,395.72,382,397Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.21,397.28a.53.53,0,0,0,.4-.22c.48-.71,3.6-3.34,6.7-2.62a1.72,1.72,0,0,0-1.07-1.1,9.32,9.32,0,0,0-6.48,3.18.48.48,0,0,0,.14.68A.58.58,0,0,0,372.21,397.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,316.57a48.29,48.29,0,0,1-4.4,5.55l1.25,1.05A17.66,17.66,0,0,0,314.47,316.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.27,256.29c5.56.85,8.78,3.78,8.94,8.17s-6.76,21.21-6.76,21.21q5.1,4.6,10.5,8.86c1.38,1.08,2.79,2.15,4.2,3.2.8.59,3.37,1.88,3.51,2.91a1.8,1.8,0,0,1-.23,1c-1.34,2.88-4.42,5.39-7.56,4.14-2.7-1.08-5.65-2.48-8.33-3.83a71.94,71.94,0,0,1-8.12-4.58c-1.64-1.11-3.39-2-4.58-3.6C306.9,291,317.27,256.29,317.27,256.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,262.05c-1.9,2.86-7.63,19.53-11.83,51,5.6,6.09,33.92,7.57,42.5-5.42,0,0,3.73-28.58,3.67-34.81,0-4.31,1.26-14-6.29-16.71l-11.3-.76L293,257.13A43.24,43.24,0,0,0,289.22,262.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.55,262.86c1.94,1.41,5.5,2.46,7.72,1.86s3-2.71,3.16-4.86l-2.58.37-1,1.57-1.3-1Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.55,262.86c1.94,1.41,5.5,2.46,7.72,1.86s3-2.71,3.16-4.86l-2.58.37-1,1.57-1.3-1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.33,
    cy: 229.13,
    r: 11.63,
    transform: "translate(-28.84 411.95) rotate(-63.83)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.85,236.44s1.47,8.93,2.15,10.42a4,4,0,0,0,2.23,2l.16-6.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.81,223.88a4.36,4.36,0,0,0-3.66,1.1c-1.63,1.51-1,6.51.7,11.46l3.53.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15,237.12c-.77-.1-1-1.33-1.84-2.29a3.5,3.5,0,0,0-5.59.85c-1.6,3,.92,7.18,3.14,8,3.83,1.4,4.53-1.06,4.53-1.06l-.37,14c2.24,2.74,10.82,4.13,11.85,5.16,0,0,1.59-2.83.81-4.94l.19-4.26a24.21,24.21,0,0,0,5.22.51c2.88-.3,4.78-2.47,5.8-5.52,1.62-4.9,2.34-8.89,1.62-18.71-.78-10.77-13.23-11.47-20.15-7.55S300.15,237.12,300.15,237.12Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39,238.27c-.67-.14-1.23-2.6-2.08-3.44-1.17-1.18.5-11,.5-11a4.78,4.78,0,0,1,1.43-5A10.15,10.15,0,0,1,310,216a92.4,92.4,0,0,0,9.37,1.62,21.45,21.45,0,0,0,9.72-1.15,10,10,0,0,1-.61,5.16,8,8,0,0,1-3.34,3.65c-1.66,1-3.35,1.55-6.82,1.69a39.79,39.79,0,0,1-12.68-1.37c-1.31-.25-1.65,1-2.53,4.48C302.35,233.13,303.46,238.88,300.39,238.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.78,224.67l-4.19-2.51a2.38,2.38,0,0,1,3.31-.93A2.57,2.57,0,0,1,298.78,224.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.87,252.6s-6.32-1.59-8.49-2.88a7.36,7.36,0,0,1-2.94-3.19,10.12,10.12,0,0,0,1.58,3.68c1.54,2.16,9.77,4.08,9.77,4.08Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,233.82l-.53,0a16,16,0,0,0-5.36.44c-1.74.61-2.38,1.22-3.33,1.27s-1.6-.5-3.38-.92a18.11,18.11,0,0,0-5.7.13l-.58.09a1.07,1.07,0,0,0-.71,1,1.84,1.84,0,0,0,.47,1.06,1.17,1.17,0,0,1,.16.43,17.7,17.7,0,0,0,.48,3,3.2,3.2,0,0,0,.65,1.05,2.59,2.59,0,0,0,.35.31l.21.13a2.52,2.52,0,0,0,.62.27l.1,0,.17,0,.17,0a3.31,3.31,0,0,0,.56.06h.55a4.49,4.49,0,0,0,4.07-2.45c.66-1.17.63-2.79,1.71-2.84h.2c.78.15.58,1.64,1,2.68a3.55,3.55,0,0,0,.68,1.13,1.37,1.37,0,0,0,.17.17l.09.08a.39.39,0,0,0,.1.08l.08.07.1.06.08.05.05,0a3.25,3.25,0,0,0,.91.32l.08,0a4.6,4.6,0,0,0,1.14,0,3.82,3.82,0,0,0,3.46-2.27,20.45,20.45,0,0,0,.89-3.06,1,1,0,0,1,.23-.41,2.33,2.33,0,0,0,.57-1.14C328.82,234.27,328.53,233.85,328.24,233.82Zm-11.56,4.87a3.84,3.84,0,0,1-.93,1.63h0a3.77,3.77,0,0,1-2.62,1,2.5,2.5,0,0,1-2.38-1l-.07-.11-.06-.11a.47.47,0,0,1-.05-.1s0-.07-.05-.1l0-.07,0-.07s0-.08,0-.11h0c0-.12-.07-.23-.1-.33h0c0-.07,0-.13-.05-.2s0-.22,0-.32v-.12c-.13-.79-.23-2.35.2-2.73a5,5,0,0,1,3.26-.72h.18c.27,0,.53,0,.79.09l.3.06a6.92,6.92,0,0,1,.76.21l.23.09.25.11.05,0,.09.05a1.43,1.43,0,0,1,.5.4A3.62,3.62,0,0,1,316.68,238.69Zm10.21-.87a4,4,0,0,1-1.84,2.65,3.16,3.16,0,0,1-1.32.35,2.49,2.49,0,0,1-2.52-1.07h0l0-.07-.05-.08,0,0-.06-.13-.06-.14a.64.64,0,0,0,0-.07l0,0s0,0,0-.06l0-.05a3.64,3.64,0,0,1-.12-.59,3.83,3.83,0,0,1,.23-2.42,5.41,5.41,0,0,1,2.94-1.33,6.46,6.46,0,0,1,.8-.1h.71l.22,0,.39,0,.1,0h0l.07,0,.09,0,.11,0,.19.07h0a1.2,1.2,0,0,1,.41.25C327.44,235.42,327.12,237,326.89,237.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37,234.88,297,234a3.64,3.64,0,0,1,1.79,1.41l10.34,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.48,237.66a1.13,1.13,0,0,1-1.23,1,1.14,1.14,0,0,1-1-1.28,1.11,1.11,0,1,1,2.21.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,245l3.72,1.88a2.05,2.05,0,0,1-2.78,1A2.19,2.19,0,0,1,313.07,245Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.71,233l-2.8-.78a1.45,1.45,0,0,1,2.8.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,232.59l-2.79.85a1.46,1.46,0,0,1,2.79-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.13,237.45a1.12,1.12,0,1,1-1-1.27A1.14,1.14,0,0,1,324.13,237.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.57,237l-.26,6.87,4.27-1.15L319,236.89A.76.76,0,0,0,318.57,237Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,326.9v.82a2.3,2.3,0,0,0,1.15,2l21.92,12.62a2.39,2.39,0,0,0,1.16.3,2.31,2.31,0,0,0,1.14-.3l40.23-23.23a2.3,2.3,0,0,0,1.15-2v-.56L320.9,341.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,316.55l-23.85-13.77a1.39,1.39,0,0,0-1.37,0l-41.38,23.9a.3.3,0,0,0,0,.52l24.08,13.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.87,305.76c1.85.7,2.14,1.52,3.64,2.37a10.79,10.79,0,0,0,5.36,1.46,18.48,18.48,0,0,1,3.45,1.64c2,1.35,2.77,1.64,5.21.88,2.66-.84.78-3.48,0-4.78a46.62,46.62,0,0,0-4.09-5.63c-.85-.78-5.29-1.47-9.12-3.81C331.36,299,330.08,301.86,329.87,305.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.68 339.08 307.81 331.66 345.43 309.94 358.36 317.32 320.68 339.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.35 318.44 314.59 318.58 320.9 322.22 332.11 315.74 332.34 315.61 325.8 311.83 314.35 318.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.59 318.58 320.9 322.22 332.11 315.74 325.8 312.1 314.59 318.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9,341.1v1.53a2.31,2.31,0,0,0,1.14-.3l40.23-23.23a2.3,2.3,0,0,0,1.15-2v-.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.9,341.1v1.53a2.31,2.31,0,0,0,1.14-.3l40.23-23.23a2.3,2.3,0,0,0,1.15-2v-.56Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.54,341.44a2.7,2.7,0,0,0,2.35-.18l40.05-23.12a2.73,2.73,0,0,0,1.33-1.9l4.38-26.15a3.42,3.42,0,0,0,0-.45,2.73,2.73,0,0,0-.81-1.94l-41.62,24a2,2,0,0,0-1,1.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9,341.11l.27.15a3.14,3.14,0,0,0,.37.18l4.74-28.29a2,2,0,0,1,1-1.41l41.62-24a2.86,2.86,0,0,0-.55-.42l-41.71,24.08a2,2,0,0,0-1,1.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,317.31a8.84,8.84,0,0,1,4-5.2c1.93-1.11,3.26-.6,3,1.15a8.8,8.8,0,0,1-4,5.19C345.14,319.57,343.81,319.06,344.1,317.31Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.4,317.22c-4.47-2.27-20.09-10-25.13-13-4.17-2.48-5.87-4.7-5.38-7.81.45-2.89,7-24.42,9.61-29.93,2.32-4.84,7.73-7.73,13-8.95,3.67,4.27,1,16.94-2.57,21.57a161,161,0,0,0-5.69,15.58s7.31,5.65,13.93,9.71c3.59,2.2,6.85,4.84,9.78,6.37,2.57,1.33,6.44,3.84,7.12,4.76s4.08,6.43,4.87,7.72c2.14,3.52.27,4.26-2.5,4.59-2.54.3-4.29-1.08-6-2.78a25.43,25.43,0,0,1-2.18-2.63,9.65,9.65,0,0,1-5.4-2.17C302.59,319.14,300.4,317.22,300.4,317.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.31,286.2s3.26-11,4.85-15.33c2.21-6,3.23-7.69,6.65-11,3-2.95,9.22-2.73,9.22-2.73,2.54,2.16,3,5.81,2,12.14a25.44,25.44,0,0,1-4.3,10.59l-5.8,14.47,17.53,12.87a12.37,12.37,0,0,0-5.75,8.15s-15.47-7.39-20.41-10-7.38-4.33-6.72-8.57A86.44,86.44,0,0,1,272.31,286.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15,251.94c-1.31.34-2.4,2.76-3.2,3.79s1.13,5.51,5,7.65,6.25,2.15,6.25,2.15.47-2.78,1.17-3.48a2,2,0,0,1,2.51-.25s0-1.87-2.5-2.21-7.6-2.56-9.27-5.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.87,261.8a4.08,4.08,0,0,1,.39-2.11,6.93,6.93,0,0,0,.42-2.83l.16-3.67a2.62,2.62,0,0,1,1.31.67,15.42,15.42,0,0,1,1.67,3.39c.31,1.18.36,5.2-.59,6.56,0,0-.54-2.32-1.29-2.82C312.85,260.28,311.87,261.8,311.87,261.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.74,266.66c-.93,6.1-3.17,27.54-3.09,29.46s2.85,9.66,4.45,8.43c.87-.67,4.31-8.69,4.17-10.73s-2.54-27.88-2.54-27.88S312.15,264,310.74,266.66Z",
    style: {
      fill: "#54BDC1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.73,265.94s-1.58-1.94-3,.72c-.13.85-.29,2-.46,3.36a11.82,11.82,0,0,1,1.4-3A5.39,5.39,0,0,1,313.73,265.94Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.87,261.12c-1.67.32-2.48.93-2.43,2.1a8,8,0,0,0,1.3,3.44,4,4,0,0,1,3-.72,6.75,6.75,0,0,0,.76-3C314.53,261.25,313.84,260.75,311.87,261.12Z",
    style: {
      fill: "#54BDC1"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDoing);
export default __webpack_public_path__ + "static/media/img_doing.549ca5ca22b004558b13d51dcb0a2872.svg";
export { ForwardRef as ReactComponent };